import "react-datepicker/dist/react-datepicker.css";
import "rsuite/dist/rsuite.min.css";
import "../PurchaseOrder/purchaseOrder.css";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { modalAnatomy as parts } from "@chakra-ui/anatomy";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
  Divider,
  Tooltip,
  Text,
} from "@chakra-ui/react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import {
  createMultiStyleConfigHelpers,
  defineStyle,
} from "@chakra-ui/styled-system";
import DatePicker from "react-datepicker";
import { createListForSingleOption, createOption } from "../createableSelect";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  calculateTotalCredit,
} from "jsFunctions/helperFunctions";
import CustomSelect from "components/CustomSelect";
import { FormValidation } from "validation";
import { fetchAsyncGetFormOptions } from "redux/formOptions";
import {  Tab, Tabs } from "react-bootstrap";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import ClientProjectSelect from "components/ClientProjectSelect";
import { clientProjectOptions } from "jsFunctions/clientProjectOptions";
import RefundInfoListComponent from "../refundListInfoComponent";
import { fetchAsyncGetClient } from "redux/clientProjectSlice";
import { FaCheck, FaPlus, FaPlusCircle } from "react-icons/fa";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import {
  getOptionDataOnEdit,
} from "jsFunctions/calculateGst";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import { fetchAsyncDeleteCreditListItem } from "redux/creditSlice";
import CreditForm from "../seprateFormComponent/creditForm";
import CreditApplicable from "../seprateFormComponent/creditApplicable";
import { addCreditAmountValidate } from "validation/creditAmount";
import { creditAmountMismatch, isValidateCredit } from "../CreditAmount/credit";
import AddItemComponent from "./addItemComponent";

import {
  createFormOptionApi,
  createMinorSubCategoryApi,
  createSubCategoryApi,
  deleteFromOptionApi,
  deleteMinorSubCategoryApi,
  deleteSubCategoryApi,
  editFromOptionApi,
  editMinorSubCategoryApi,
  editSubCategoryApi,
  getMinorSubCategoryApi,
  getSubCategoryApi,
} from "../CommonApi/form_options";
import prJson from "components/jsonData/purchase.json";
import invJson from "components/jsonData/salesInvoice.json";

import commonJson from "components/jsonData/common.json";
import { taxOptions } from "../PurchaseItem/selectedOptions";
import InvoiceComponent from "../seprateFormComponent/InvoiceComponent";
import { InvoiceNumberFormate } from "jsFunctions/helperFunctions";
import { poNumberFormate } from "jsFunctions/helperFunctions";
import { fetchAsyncGetCreditOptionsByClientId } from "redux/creditSlice";
import { formatAmountInINR } from "jsFunctions/formatAmountInINR";
import CustomPopover from "components/customPopover/customPopover";
import CurrencySelectField from "../SalesItem/currencySelected";
import { allCurrency } from "../SalesItem/currencyJson";
import { fetchAsyncGetInvoiceNum,fetchAsyncSendRequestForApproval,fetchAsyncApproveInvoiceAmount,fetchAsyncRejectInvoiceAmount,fetchAsyncUpdateInvoiceData,fetchAsyncReSendRequestForApproval,fetchAsyncDeleteRefundItem,fetchAsyncDeleteInvoicePurchasePdf,fetchAsyncAddInvoicePurchaseRemarks,fetchAsyncUploadInvoicePurchase } from "redux/salesInvoice";
import { paymentTermsOptions } from "jsFunctions/helperFunctions";
import { SettingOutlined } from "@ant-design/icons";
import InvoiceNumberSetting from "./inNumberSetting";
import PaymentRecords from "./PaymentRecord/paymentRecords";
import TdsRecords from "./PaymentRecord/tdsRecords";
import { fetchAsyncDeletePaymentRecord } from "redux/invoicePaymentRecordSlice";
import { fetchAsyncDeleteTdsRecord } from "redux/invoicePaymentRecordSlice";
import InvoiceDataChangeModal from "components/models/DataChange/invoiceDataChangeModal";
import CurrencyFormat from "react-currency-format";
import { fetchAsyncGetPFINum } from "redux/salesInvoice";
import { salesRefundValidate } from "validation/refundAmount";
import ProformaNumberSetting from "./ProformaNumberSetting";
import { RecordPaymentValidate, sumOfInvoiceTdsAmount, sumOfInvoiceTdsBaseAmount, sumOfPaymentRecordAmount, sumOfRefundAmount } from "utiils/halper";
import TextAreaField from "../component/textAreaField";
import moment from "moment";
import { fetchAsyncGetAutomatedBank, fetchAsyncGetEmbrillProfile } from "redux/embrillProfileSlice";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);
const xl = defineStyle({ px: "6", py: "2", fontSize: "xl" });
const sm = defineStyle({ fontSize: "sm", py: "6" });
const sizes = { xl: definePartsStyle({ header: sm, dialog: xl }) };
export const modalTheme = defineMultiStyleConfig({ sizes });

const SalesInvoiceForm = (props) => {
  const {
    openModal,
    closeModal,
    isEdit = false,
    editData,
    refreshEditData,
    activeList,
    role,
    expenseType,
    prefix,
    pfPrefix,
    moduleInfo,
    isProforma = false,
    isInvoice,

  } = props;
  const formOptionsList1 = useSelector((state) => state.formOptions);
  const subCategoryList1 = useSelector((state) => state.subCategory);
  const [isInv,setIsInv] = useState(isInvoice)
  const [invPrefix, setInvPrefix] = useState({
    prfx: !isProforma ? prefix : "",
    n: !isProforma ? 1 : "",
  });
  const [pfiPrefix, setPfiPrefix] = useState({
    prfx: isProforma ? pfPrefix : "",
    n: isProforma ? 1 : "",
  });
  const [paymentRecords, setPaymentRecords] = useState([]);
  const [paymentRecordsError, setPaymentRecordsError] = useState({});

  const [tdsRecords, setTdsRecords] = useState([]);
  const [isTds, setIsTds] = useState(false);
  const [totalPaymentAmount, setTotalPaymentAmount] = useState(0);
  const [taxableAmount,setTaxableAmount] = useState(0);
  const [approvedAmount,setApprovedAmount] = useState(0)
  const [requestedAmount,setRequestedAmount] = useState(0)

  const [isSetting,setIsSetting] = useState(false)
  const [isPfSetting,setIsPfSetting] = useState(false)

  const [formOptionsList, setFormOptionsList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [generatedNum, setGeneratedNum] = useState("");
  const [generatedPfiNum, setGeneratedPfiNum] = useState("");

  const [termsOptions, setTermsOptions] = useState([]);
  const [termsValue, setTermsValue] = useState("");
  const [currency, setCurrency] = useState("");
  const [purchaseNumber, setPurchaseNumber] = useState("");
  const [purchaseDate, setPurchaseDate] = useState(new Date());
  const [isHovered, setIsHovered] = useState(false);
  const [clientOPtion, setClientOption] = useState([]);
  const [minorTypeOption, setMinorTypeOption] = useState([]);
  const [projectOption, setProjectOption] = useState([]);
  const [majorOptions, setMajorOptions] = useState([]);
  const [minorSubCategoryOption, setMinorSubCategoryOption] = useState([]);
  const [refundRecords, setRefundRecords] = useState([{}]);
  const [approveOrRejectRemarks, setApproveOrRejectRemarks] = useState("");
  const [adjustmentAmount, setAdjustmentAmount] = useState(0);
  const [shippingCharge, setShippingCharge] = useState(0);
  const [isFright, setIsFright] = useState(false);
  const [adjustmentLabel, setAdjustmentLabel] = useState("Adjustment");

  const [multipleCredit, setMultipleCredit] = useState([]);
  const [creditAmount, setCreditAmount] = useState("");
  const [paymentStatus, setPaymentStatus] = useState(0);
  const [clientValue, setClientValue] = useState("");
  const [minorTypeValue, setMinorTypeValue] = useState("");
  const [invoiceMode, setInvoiceMode] = useState("default");
  const [proformaMode, setProformaMode] = useState("default");

  const [isLoading, setIsLoading] = useState(false);
  const [projectValue, setProjectValue] = useState("");
  const [majorValue, setMajorValue] = useState("");
  const [minorSubCategoryValue, setMinorSubCategoryValue] = useState("");
  const [proformaDate, setProformaDate] = useState(isProforma ? new Date() : "");

  const [invoiceDate, setInvoiceDate] = useState(new Date());
  const [dueDate, setDueDate] = useState(new Date());
  const [proformaDueDate, setProformaDueDate] = useState(isProforma ? new Date() : "");
  const isFormDataSetRef = useRef(false);
  const [invSubject, setInvSubject] = useState("");

  const [multipleInvoiceData, setMultipleInvoiceData] = useState([]);
  const dispatch = useDispatch();
  const [multipleItemList, setMultipleItemList] = useState([
    {
      slItm: {},
      qty: 1,
      prc: "",
      tax: {},
      amt: 0,
    },
  ]);
  const [refundAmountError, setRefundAmountError] = useState([{}]);
  const [creditError, setCreditError] = useState([{}]);
  const [totalCreditAmount, setTotalCreditAmount] = useState(0);
  const [compareDataModal, setCompareDataModal] = useState(false);
  const [comparingData, setComparingData] = useState(null);
  const [isRefund, setIsRefund] = useState(false);
  const [addCredit, setAddCredit] = useState(false);
  const [gstRecords, setGstRecords] = useState([{}]);
  const [isCredit, setIsCredit] = useState(false);
  const [roundOfAmount, setRoundOfAmount] = useState("");
  const [creditValid, setCreditValid] = useState(true);
  const [isAddCredit, setIsAddCredit] = useState(false);

  const fetchPaymentTermsOptions = async (array) => {
    const trmsOpts = await paymentTermsOptions("name", "days", array);
    setTermsOptions(trmsOpts);
    setTermsValue(prev => prev || trmsOpts[0]);
  };

  const totalReceivedAmount = useMemo(() => {
    if (paymentRecords) {
      if (paymentRecords.length > 0) {
        const total = sumOfPaymentRecordAmount(paymentRecords || [])
        const totalRefund = sumOfRefundAmount(refundRecords || [])

        return parseFloat(total) - parseFloat(totalRefund); 
      }
    }
    return 0;
  }, [paymentRecords,refundRecords]);

  const totalTdsAmount = useMemo(() => {
    if (tdsRecords) {
      const total = sumOfInvoiceTdsAmount(tdsRecords)
      return total;
    }
    return 0;
  }, [tdsRecords]);

  const remainingTdsAmount = useMemo(() => {
    const tdsBsAmt = sumOfInvoiceTdsBaseAmount(tdsRecords)
    const total = parseFloat(taxableAmount) - parseFloat(tdsBsAmt)
    return total;
  }, [taxableAmount,tdsRecords]);


  const totalReceivableAmt = useMemo(() => {
    if (paymentRecords) {
        const total = sumOfPaymentRecordAmount(paymentRecords || [])
        return parseFloat(approvedAmount) - (parseFloat(totalTdsAmount) + parseFloat(creditAmount) + parseFloat(total)); 
    }
    return 0;
  }, [paymentRecords,approvedAmount,totalTdsAmount,creditAmount]);

  const fetchNextInvoiceNumber = ()=>{
    dispatch(
      fetchAsyncGetInvoiceNum({
        moduleId:moduleInfo?._id
      })
    )
      .then((res) => {
        let newNumber = 1;
        if (res.payload && res.payload?.number) {
          newNumber = res.payload?.number;
        }
        setInvPrefix((prev) => {
          return {
            prfx: prefix,
            n: newNumber,
          };
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const fetchNextProformaNumber = ()=>{
    dispatch(
      fetchAsyncGetPFINum({
        moduleId:moduleInfo?._id
      })
    )
      .then((res) => {
        let newNumber = 1;
        if (res.payload && res.payload?.number) {
          newNumber = res.payload?.number;
        }
        setPfiPrefix((prev) => {
          return {
            prfx: prev.prfx,
            n: newNumber,
          };
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    if (moduleInfo?.pyTrms?.length) {
      // -1 has the semantic meaning of "Custom" terms,
      // where due days are calculated by subtracting invoice date from due date
      fetchPaymentTermsOptions([...moduleInfo.pyTrms,{
        name: "Custom",
        days: -1,
      }]);
    }
    if (!isEdit && isInv) {
      fetchNextInvoiceNumber()
    }
    if (!isEdit && isProforma) {
      fetchNextProformaNumber()
    }
  }, [moduleInfo,isInv,isProforma]);

  useEffect(() => {
    if(isInv) setGeneratedNum(InvoiceNumberFormate(invPrefix));
    if(isProforma) setGeneratedPfiNum(InvoiceNumberFormate(pfiPrefix))
  }, [invPrefix,isProforma,pfiPrefix,isInv]);

  

  const [allCreditOption, setAllCreditOptions] = useState([]);

  const [allCreditData, setAllCreditData] = useState([]);

  const finalRef = useRef(null);
  const { addToast } = useToasts();
  const [remarksValue, setRemarksValue] = useState("");
  const [customerNotes, setCustomerNotes] = useState("");

  const [errors, setErrors] = useState({});
  const clientData = useSelector((state) => state.clientData);
  const manualBanks = useSelector(state=>state.embrillProfileData);
  const [automatedBank,setAutomatedBank] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);

  const bankOptions = useMemo(() => {
    const allBanks = manualBanks?.map?.(b => ({
      label: b.aliasName || b.bnk,
      value: b._id,
      bankType: "manual",
    })) || [];
    if (automatedBank) {
      allBanks.push({
        label: automatedBank.bnk.name,
        value: automatedBank._id,
        bankType: "automated",
      });
    }
    return allBanks
  }, [automatedBank, manualBanks]);

  const [activeTab, setActiveTab] = useState("items");

  const initialValues = {};

  const getAutomatedBanks = async () => {
    try {
      const res = await dispatch(fetchAsyncGetAutomatedBank());

      if(res?.payload){
        setAutomatedBank(res.payload);
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    dispatch(fetchAsyncGetClient());
    dispatch(fetchAsyncGetFormOptions());
    dispatch(fetchAsyncGetEmbrillProfile());
    getAutomatedBanks();
  }, []);

  useEffect(() => {
    if (!editData?.selectedBankId?._id) {
      const primaryBank = manualBanks?.find(b => b.isPrimary);
      if (primaryBank) {
        const bankOption = bankOptions?.find(b => b.value === primaryBank._id);
        setSelectedBank(bankOption);
      } else {
        setSelectedBank(null);
      }
    } else {
      const selectedBank = bankOptions?.find(o => o.value === editData.selectedBankId._id);
      if (selectedBank) {
        setSelectedBank(selectedBank);
      } else {
        const primaryBank = manualBanks?.find(b => b.isPrimary);
        if (primaryBank) {
          const bankOption = bankOptions?.find(b => b.value === primaryBank._id);
          setSelectedBank(bankOption);
        } else {
          setSelectedBank(null);
        }
      }
    }
  }, [manualBanks, bankOptions, editData?.selectedBankId,editData?.selectedBankIdModel]);

  useEffect(() => {
    if (formOptionsList1 && formOptionsList1?.length > 0) {
      const internalFormOptionList = formOptionsList1.filter(
        (item) => item.expTyp === expenseType
      );
      setFormOptionsList(internalFormOptionList);
    }
  }, [formOptionsList1]);

  useEffect(() => {
    if (subCategoryList1 && subCategoryList1?.length > 0) {
      const internalSubCategoryList = subCategoryList1.filter(
        (item) => item.expTyp === expenseType
      );
      setSubCategoryList(internalSubCategoryList);
    }
  }, [subCategoryList1]);

  const closeComparedDataModal = () => {
    setCompareDataModal(false);

    setComparingData(null);
  };
  const submitUpdateData = (formData, editData) => {
    setIsLoading(true);
    dispatch(
      fetchAsyncUpdateInvoiceData({ 
        id: editData._id, 
        formData: formData,
        moduleId: moduleInfo?._id 
 
      })
    )
      .then((res) => {
        if (res.payload) {
          setIsLoading(false);
          const msg = prJson.confirm.updatePurchase.replace(
            "{generatedNum}",
            isInv ? generatedNum : generatedPfiNum
          );
          addToast(msg, { appearance: "success" });
        }
        closeModal("approved");
        formik.resetForm();
      })
      .catch((error) => {
        setIsLoading(false);
        addToast("Error", { appearance: "error" });
      });
  };

  const getAllClientOptions = async () => {
    if (clientData) {
      const clientOption = await clientProjectOptions(
        "clName",
        "_id",
        clientData
      );
      setClientOption(clientOption);
    }
  };

  const getAllProjectOptions = async (clientId) => {
    const client = clientData.find((client) => client._id === clientId);
    if (client) {
      const projects = client?.prjs || [];
      if (projects) {
        const projectOption = await clientProjectOptions(
          "prj",
          "_id",
          projects
        );
        setProjectOption(projectOption);
        setProjectValue("");
        if (isEdit && editData && editData?.prId && editData.prId?._id) {
          const subCat = projectOption.filter(
            (option) => option.value === editData.prId?._id
          );
          if (subCat[0]) {
            setProjectValue({
              label: subCat[0].label,
              value: subCat[0].value,
            });
          }
        }
      }
    }
  };

  // Set MinorCategory for selected majorType value
  useEffect(() => {
    if (clientValue && clientValue?.value) {
      getAllProjectOptions(clientValue?.value);
      const clientId = clientValue.value;
      getAllCreditByClientID(clientId);
    }
  }, [clientValue]);

  useEffect(() => {
    getAllClientOptions();
    let majorList = createListForSingleOption(formOptionsList, "expense");
    setMajorOptions(majorList);
  }, [formOptionsList]);

  const getFormData = (values) => {
    let formData = new FormData();
    formData.append("inNo", JSON.stringify(invPrefix));
    formData.append("invoiceDate", invoiceDate);
    formData.append("proformaDate", proformaDate);
    formData.append("pfiNo", JSON.stringify(pfiPrefix));
    formData.append("isProforma", isProforma);
    formData.append("isInvoice", isInv);
    formData.append("currency", currency?.code);
    formData.append("dueDate", dueDate);
    formData.append("proformaDueDate", proformaDueDate);
    formData.append("adjustmentAmount", adjustmentAmount);
    formData.append("shippingCharge", shippingCharge);
    formData.append("isFright", isFright);
    formData.append("purchaseNumber", purchaseNumber);
    formData.append("invoiceMode", invoiceMode);
    formData.append("proformaMode", proformaMode);
    formData.append("adjustmentLabel", adjustmentLabel);

    formData.append("purchaseDate", purchaseDate);
    formData.append("invoiceSubject", invSubject);
    formData.append("termsValue", termsValue?.value);
    formData.append("roundOfAmount", roundOfAmount);
    formData.append("expense_name", moduleInfo?.name);
    formData.append("category", moduleInfo?._id);
    formData.append("clientName", clientValue?.value);
    formData.append("projectName", projectValue?.value);
    formData.append("remarks", remarksValue);
    formData.append("customerNotes", customerNotes);
    formData.append("majorId", majorValue.id || "");
    formData.append("minorId", minorTypeValue?.id || "");
    formData.append("minorSubCategoryId", minorSubCategoryValue?.id || "");
    formData.append("expenseType", majorValue?.value);
    formData.append(
      "minorTypeCategory",
      minorSubCategoryValue.value ? minorSubCategoryValue.value : ""
    );
    formData.append("minorType", minorTypeValue.value);
    formData.append("totalPaymentAmount", totalPaymentAmount);
    formData.append("requestedAmount", requestedAmount);
    formData.append("taxableAmount", taxableAmount);

    const filteredGstRecords = gstRecords?.filter(r => r?.bsAmt);
    formData.append("gstRecords", JSON.stringify(filteredGstRecords));
    formData.append("isRefund", isRefund);
    formData.append("selectedBank", JSON.stringify(selectedBank));
    const filteredMultipleAddRefundInfoPay = refundRecords?.filter(
      (item) => item?.amt
    );

    formData.append(
      "refundInfo",
      JSON.stringify(filteredMultipleAddRefundInfoPay)
    );
    formData.append("approveRejectRemarks", approveOrRejectRemarks);

    const filteredTdsRecords = tdsRecords.filter((item) => item?.bsAmt);

    formData.append("tdsRecords", JSON.stringify(filteredTdsRecords));
    
    const filteredInvoice = multipleInvoiceData?.filter((item) => item?.file);
    formData.append("invoiceData", JSON.stringify(filteredInvoice));
    filteredInvoice.forEach((inv, idx) => {
      formData.append(`invoiceFiles[${idx}]`, inv.file);
    });
    return formData;
  };

  const formik = useFormik({
    initialValues,
    validationSchema: FormValidation,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      if (
        (!selectedBank && !!bankOptions?.length) ||
        (isInv && !dueDate) ||
        (isProforma && !proformaDueDate) ||
        !clientValue ||
        !minorTypeValue ||
        !projectValue ||
        !majorValue ||
        (minorSubCategoryOption &&
          minorSubCategoryOption?.length &&
          !minorSubCategoryValue)
      ) {
        setErrors({
          ...errors,
          projectValue: prJson.required.project,
          minorTypeValue: prJson.required.minorType,
          majorValue: prJson.required.majorType,
          selectedBank: prJson.required.selectedBank,
          dueDate: prJson.required.dueDate,
          proformaDueDate: prJson.required.proformaDueDate,
          invoiceDate: prJson.required.invoiceDate,
          proformaDate: prJson.required.proformaDate,
          clientValue: prJson.required.clientName,
          minorSubCategoryValue:
            minorSubCategoryOption && minorSubCategoryOption?.length
              ? prJson.required.minorSub
              : "",
        });
        addToast(prJson.required.allField, { appearance: "error" });
        return;
      }

      const pmtErrors = RecordPaymentValidate(
        paymentRecords
      );
      if (Object.keys(pmtErrors).length !== 0) {
        setPaymentRecordsError(pmtErrors)
        if(activeTab && activeTab !== 'paymentRecord'){
          addToast('check payment records!', { appearance: "error" });
        }
        return;
      }
      if(isRefund){
        const refundError = salesRefundValidate(
          refundRecords
        );
        if (Object.keys(refundError).length !== 0) {
          setRefundAmountError(refundError)
          if(activeTab !== 'refund'){
            addToast(prJson.error.checkRefund, { appearance: "error" });
          }
          return;
        }
        }
      let formData = getFormData(values);

      const filteredMultipleItemData = multipleItemList.filter(
        (item) => item?.slItm?._id
      );
      formData.append("itemInfo", JSON.stringify(filteredMultipleItemData));
      const filteredPaymentRecords = paymentRecords.filter((item) => item?.amt);

      formData.append("pmtRecords", JSON.stringify(filteredPaymentRecords));

      if (isEdit) {
        setComparingData(formData);
      }
    },
  });

  const handleInvoiceChange = () => {
    if (multipleInvoiceData) {
      if (multipleInvoiceData?.length < 5) {
        setMultipleInvoiceData([
          ...multipleInvoiceData,
          {
            spId: "",
            Key: "",
            remark: "",
            file: "",
          },
        ]);
      }
    }
  };

  const handleMultipleRefundInfo = (data) => {
    setRefundRecords([...refundRecords, ""]);
  };
  const handleUpdateMultipleRefundData = (payData, index) => {
    const updateList = refundRecords.map((item, i) => {
      if (i === index) {
        return { ...item, ...payData };
      } else return item;
    });
    const refundError = salesRefundValidate(
      updateList
    );
    if (refundError) {
      setRefundAmountError(refundError)
    }
    else{
      setRefundAmountError({})
    }
    setRefundRecords([...updateList]);
  };

  const handleUpdatedMultipleCredit = (newItem) => {
    const updatedList = multipleCredit.map((item) => {
      if (item?._id === newItem?._id) {
        return newItem;
      } else {
        return item;
      }
    });
    const creditError = addCreditAmountValidate(updatedList, totalCreditAmount);
    if (creditError) {
      setCreditError(creditError);
    }

    setMultipleCredit(updatedList);
  };

  const handleUpdateInvoiceData = (invoiceData, index) => {
    const newData = [...multipleInvoiceData];
    newData[index].file = invoiceData;
    setMultipleInvoiceData(newData);
  };
  const handleAddInvoiceRemarks = (value, index) => {
    const newData = [...multipleInvoiceData];
    newData[index].remark = value;
    setMultipleInvoiceData(newData);
  };
  const handelDeleteInvoice = (index, id) => {
    if (multipleInvoiceData) {
      let invoices = multipleInvoiceData.filter((item, i) => i !== index);
      setMultipleInvoiceData(invoices);
    }
  };

  const handleStateUpdate = (type, setData) => {
    const typeHandlers = {
      expense: () => {
        setMajorValue(setData);
        setMinorTypeValue("");
        setMinorSubCategoryValue("");
      },
    };

    if (typeHandlers[type]) {
      typeHandlers[type]();
    }
  };

  const createNewFormOption = async (data, type) => {
    const setData = await createFormOptionApi(
      data,
      type,
      dispatch,
      expenseType
    );
    if (setData) {
      handleStateUpdate(type, setData);
    }
  };

  const deleteFromOption = (option, type) => {
    let data = formOptionsList.find(
      (item) => item._id === option.id && item.typ === type
    );
    if (data?._id) {
      deleteFromOptionApi(dispatch, data._id).then((result) => {
        if (result.success) {
          addToast(result.message, { appearance: "success" });
        } else {
          addToast(result.message, { appearance: "error" });
        }
      });
    }
  };

  const editFromOption = (option, newValue, type) => {
    let data = formOptionsList.find(
      (item) => item._id === option.id && item.typ === type
    );
    editFromOptionApi(dispatch, data._id, newValue, expenseType).then(
      (result) => {
        if (result.success) {
          addToast(prJson.success.updatedOpt, { appearance: "success" });
          if (result.data) {
            handleStateUpdate(type, result.data);
            dispatch(fetchAsyncGetFormOptions());
          }
        } else {
          addToast(result.message, { appearance: "error" });
        }
      }
    );
  };

  const editFormPrefiledData = (formOptionsList, editData) => {
    const clientData = editData?.clId;
    if (clientData) {
      setClientValue({ label: clientData.clName, value: clientData._id });
    }

    const expense = getOptionDataOnEdit(
      formOptionsList,
      editData?.mjId?._id,
      "expense"
    );
    if (expense) {
      setMajorValue({
        label: expense.lab,
        value: expense.val,
        id: expense?._id,
      });
    }
  };
 

  useEffect(() => {
    if (isEdit && editData) {
      if (formOptionsList?.length > 0 && editData) {
        editFormPrefiledData(formOptionsList, editData);
      }
    }
  }, [formOptionsList])
 

  useEffect(() => {
    if (isEdit && editData) {
      setInvPrefix(editData.inNo);
      setPfiPrefix(editData.pfiNo);
      const todayStartOfDay = moment().startOf('day').toDate();
      if(editData.inDt){
        setInvoiceDate((editData.inDt && new Date(editData.inDt)) || todayStartOfDay);
      }
      if(editData.pfiDt){
        setProformaDate((editData.pfiDt && new Date(editData.pfiDt)) || todayStartOfDay);
      }

      if (editData.duDt) {
        setDueDate(new Date(editData.duDt));
      } else if (isInv) {
        const invoiceDate = (editData.inDt && new Date(editData.inDt)) || todayStartOfDay;
        if (Number.isFinite(editData?.tDays) && editData.tDays >= 0) {
          const newDueDate = moment(invoiceDate)
            .add(editData.tDays, "days")
            .toDate();

          setDueDate(newDueDate);
        } else { // custom, but no due date selected!
          editData.tDays = 0;
          setDueDate(invoiceDate);
        }
      }

      if (editData.pfiDuDt) {
        setProformaDueDate(new Date(editData.pfiDuDt));
      } else if (isProforma) {
        const proformaDate = (editData.pfiDt && new Date(editData.pfiDt)) || todayStartOfDay;
        if (Number.isFinite(editData.tDays) && editData.tDays >= 0) {
          const newDueDate = moment(proformaDate)
            .add(editData.tDays, "days")
            .toDate();

          setProformaDueDate(newDueDate);
        } else { // custom, but no due date selected!
          editData.tDays = 0;
          setProformaDueDate(proformaDate);
        }
      }

      setInvSubject(editData?.invSub);
      if (editData.pyInfo?.tlAmt) {
        setTotalPaymentAmount(editData.pyInfo?.tlAmt);
      }
      if (editData.pyInfo?.txAmt) {
        setTaxableAmount(editData.pyInfo?.txAmt);
      }
      if (editData.pyInfo?.apAmt) {
        setApprovedAmount(editData.pyInfo?.apAmt);
      }
      if (editData.pyInfo?.pNo) {
        setPurchaseNumber(editData.pyInfo?.pNo);
      }
      if (editData.pyInfo?.pDt) {
        setPurchaseDate(new Date(editData.pyInfo?.pDt));
      }
      if(editData?.inCr){
        const curr = allCurrency.find((opt)=>opt.code === editData.inCr)
        setCurrency(curr)
      }
      if (editData?.cNts) {
        setCustomerNotes(editData.cNts);
      }

      if (editData.pyInfo?.inv && editData.pyInfo?.inv?.length > 0) {
        setMultipleInvoiceData(editData.pyInfo?.inv);
      }
      if (editData.pmtRc && editData.pmtRc?.length > 0) {
        setPaymentRecords(editData.pmtRc);
      }
      if (editData?.tdsApl?.tdsRc && editData?.tdsApl?.tdsRc?.length > 0) {
        setTdsRecords(editData?.tdsApl?.tdsRc);
      }
      if (editData?.tdsApl?.sts && editData?.tdsApl?.sts) {
        setIsTds(true);
      }
      if (editData.pyInfo?.itms && editData.pyInfo?.itms.length > 0) {
        setMultipleItemList(editData.pyInfo?.itms);
      }

      if (editData?.acRmks) {
        setApproveOrRejectRemarks(editData?.acRmks);
      }

      if (editData?.adjAmt) {
        setAdjustmentAmount(editData?.adjAmt);
      }
      if (editData?.adjLab) {
        setAdjustmentLabel(editData?.adjLab);
      }
      if (editData?.shpCrg) {
        setShippingCharge(editData?.shpCrg);
      }
      if (editData?.isFc) {
        setIsFright(editData?.isFc);
      }
      if (editData?.roAmt) {
        setRoundOfAmount(editData?.roAmt);
      }
      if (editData?.tDays !== 0) {
        const terms = moduleInfo?.pyTrms || [];
        if (editData?.tDays === -1) {
          setTermsValue({
            label:"Custom",
            value:-1,
          });
        } else {
          const selected = terms?.find((t)=>t.days === editData?.tDays)
          if(selected){
            setTermsValue({
              label:selected?.name || "",
              value:selected?.days || 0
            });
          }
        }
      }
      if (editData?.rmks) {
        setRemarksValue(editData?.rmks);
      }
      if (editData.rfdInfo?.list && editData.rfdInfo?.list.length > 0) {
        setRefundRecords(editData.rfdInfo?.list);
      }
     
      if (editData.pyInfo?.sts) {
        setPaymentStatus(editData.pyInfo?.sts);
      }
     
      if (editData?.crApl && editData?.crApl?.sts) {
        setIsCredit(editData?.crApl?.sts);
      }
      if (editData?.crApl?.list && editData?.crApl?.list?.length > 0) {
        setMultipleCredit(editData.crApl?.list);
      }

      if (editData?.rfdInfo && editData?.rfdInfo?.sts) {
        setIsRefund(editData?.rfdInfo?.sts);
      }

      if (editData.gstRc && editData.gstRc?.length > 0) {
        setGstRecords(editData.gstRc);
      }
    }

    // dispatching macro task
    setTimeout(() => isFormDataSetRef.current = true)
  }, []);

  const handleDeleteInvoiceOnEdit = (key, spId) => {
    ConfirmationDialog({
      title: prJson.confirm.invoice,
      text: `Delete File ${key}`,
      icon: "warning",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        setIsLoading(true);

        const sendData = {
          id: editData._id,
          moduleId:moduleInfo._id,
          key: key,
          spId: spId || "",
        };
        dispatch(fetchAsyncDeleteInvoicePurchasePdf(sendData))
          .then((res) => {
            if (res?.payload && res?.payload?.updatedInvoice?.pyInfo?.inv) {
              setMultipleInvoiceData(res?.payload?.updatedInvoice?.pyInfo?.inv);
              refreshEditData();
              addToast(prJson.success.deletedInvoice, {
                appearance: "success",
              });
              setIsLoading(false);
            } else {
              setIsLoading(false);
              addToast(prJson.error.generic, { appearance: "error" });
            }
          })
          .catch((error) => {
            addToast(prJson.error.generic, { appearance: "error" });
            setIsLoading(false);
          });
      },
    });
  };

  const addNewInvoiceOnEdit = (file, index) => {
    ConfirmationDialog({
      title: prJson.confirm.uploade,
      text: `Upload - ${file.name}`,
      icon: "warning",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        setIsLoading(true);

        if (editData) {
          let formData = new FormData();
          const inNo = isInv ? editData.inNo : editData?.pfiNo;
          formData.append("inNo", JSON.stringify(inNo));
          formData.append("clientId", clientValue.val || "");
          formData.append("file", file);
          formData.append("index", index);

          dispatch(
            fetchAsyncUploadInvoicePurchase({ 
              id: editData._id,
              moduleId:moduleInfo?._id, 
              formData 
            })
          )
            .then((res) => {
              if (res?.payload && res?.payload?.updatedInvoice?.pyInfo?.inv) {
                setMultipleInvoiceData(
                  res?.payload?.updatedInvoice?.pyInfo?.inv
                );
                refreshEditData();
                setIsLoading(false);
                addToast(prJson.success.uploaded, { appearance: "success" });
              } else {
                setIsLoading(false);
                addToast(prJson.error.generic, { appearance: "error" });
              }
            })
            .catch((error) => {
              addToast(prJson.error.generic, { appearance: "error" });
              setIsLoading(false);
            });
        }
      },
    });
  };

  useEffect(() => {
    if (minorTypeValue?.id) {
      getMinorSubCategoryApi(dispatch, minorTypeValue.id).then(
        (subCatResult) => {
          if (subCatResult.success) {
            const minorSubOpt = subCatResult.data.map((item) => ({
              ...item,
              label: item?.lab,
              value: item?.val,
              id: item?._id,
            }));
            setMinorSubCategoryOption(minorSubOpt);
            setMinorSubCategoryValue("");
            if (isEdit && editData && minorSubOpt.length > 0) {
              const subCat = minorSubOpt.find(
                (opt) => opt.id === editData?.msId?._id
              );
              if (subCat) {
                setMinorSubCategoryValue({
                  label: subCat?.label,
                  value: subCat?.value,
                  id: subCat?._id,
                });
              }
            }
          }
        }
      );
    }
  }, [minorTypeValue]);

  const createMinorSubCategory = (category, minorTypeData) => {
    const option = subCategoryList.find(
      (data) => data._id === minorTypeData?.id
    );
    if (!option) return;
    createMinorSubCategoryApi(dispatch, option._id, category, expenseType).then(
      (result) => {
        if (result.success) {
          setMinorSubCategoryOption((prev) => [...prev, result.data]);
          setMinorSubCategoryValue({
            label: result.data.label,
            value: result.data.value,
            id: result.data.id,
          });
          addToast(prJson.success.createdMinorSub, { appearance: "success" });
        } else {
          addToast(result.message, { appearance: "error" });
        }
      }
    );
  };

  const deleteMinorSubCategory = (option) => {
    const id = option?._id;
    if (id) {
      deleteMinorSubCategoryApi(dispatch, id).then((result) => {
        if (result.success) {
          setMinorSubCategoryOption((prev) =>
            prev.filter((cat) => cat.value !== result.value)
          );
          addToast(prJson.success.deletedMinorSub, { appearance: "success" });
        } else {
          addToast(result.message, { appearance: "error" });
        }
      });
    }
  };
  const createSubCategory = (category, expenseData) => {
    const option = formOptionsList.find((data) => data._id === expenseData?.id);
    if (!option) return;

    createSubCategoryApi(dispatch, option._id, category, expenseType).then(
      (result) => {
        if (result.success) {
          setMinorTypeOption((prev) => [...prev, result.data]);
          setMinorTypeValue({
            label: result.data.label,
            value: result.data.value,
            id: result.data.id,
          });
          addToast(prJson.success.createdSub, { appearance: "success" });
        } else {
          addToast(result.message, { appearance: "error" });
        }
      }
    );
  };

  const deleteSubCategory = (option) => {
    const id = option?._id;
    if (id) {
      deleteSubCategoryApi(dispatch, id).then((result) => {
        if (result.success) {
          setMinorTypeOption((prev) =>
            prev.filter((cat) => cat.value !== result.value)
          );
          addToast(prJson.success.deletedSub, { appearance: "success" });
        } else {
          addToast(result.message, { appearance: "error" });
        }
      });
    }
  };

  const editSubCategory = (option, newValue) => {
    editSubCategoryApi(dispatch, option?._id, newValue, expenseType).then(
      (result) => {
        if (result.success) {
          if (majorValue?.id) {
            getSubCategoryApi(dispatch, majorValue.id).then((subCatResult) => {
              if (subCatResult.success) {
                const minorOpt = subCatResult.data.map((item) => ({
                  ...item,
                  label: item?.lab,
                  value: item?.val,
                  id: item?._id,
                }));
                setMinorTypeOption(minorOpt);
                if (minorOpt.length > 0) {
                  const subCat = minorOpt.find((opt) => opt.id === option?._id);
                  if (subCat) {
                    setMinorTypeValue({
                      label: subCat?.label,
                      value: subCat?.value,
                      id: subCat?._id,
                    });
                  }
                }
              } else {
                addToast(subCatResult.message, { appearance: "error" });
              }
            });
          }
          addToast(prJson.success.updatedSub, { appearance: "success" });
        } else {
          addToast(result.message, { appearance: "error" });
        }
      }
    );
  };

  const editMinorSubCategory = (option, newValue) => {
    editMinorSubCategoryApi(dispatch, option?._id, newValue, expenseType).then(
      (result) => {
        if (result.success) {
          if (minorTypeValue?.id) {
            getMinorSubCategoryApi(dispatch, minorTypeValue.id).then(
              (subCatResult) => {
                if (subCatResult.success) {
                  const minorSubOpt = subCatResult.data.map((item) => ({
                    ...item,
                    label: item?.lab,
                    value: item?.val,
                    id: item?._id,
                  }));

                  setMinorSubCategoryOption(minorSubOpt);
                  if (minorSubOpt.length > 0) {
                    const subCat = minorSubOpt.find(
                      (opt) => opt.id === option?._id
                    );
                    if (subCat) {
                      setMinorSubCategoryValue({
                        label: subCat?.label,
                        value: subCat?.value,
                        id: subCat?._id,
                      });
                    }
                  }
                } else {
                  addToast(subCatResult.message, { appearance: "error" });
                }
              }
            );
          }
          addToast(prJson.success.updatedMinorSub, { appearance: "success" });
        } else {
          addToast(result.message, { appearance: "error" });
        }
      }
    );
  };
  // Set MinorCategory for selected majorType value
  useEffect(() => {
    if (majorValue?.id) {
      getSubCategoryApi(dispatch, majorValue.id).then((subCatResult) => {
        if (subCatResult.success) {
          const minorOpt = subCatResult.data.map((item) => ({
            ...item,
            label: item?.lab,
            value: item?.val,
            id: item?._id,
          }));
          setMinorTypeOption(minorOpt);
          setMinorTypeValue("");
          if (isEdit && editData && minorOpt.length > 0) {
            const subCat = minorOpt.find(
              (opt) => opt.id === editData?.mnId?._id
            );
            if (subCat) {
              setMinorTypeValue({
                label: subCat?.label,
                value: subCat?.value,
                id: subCat?._id,
              });
            }
          }
        }
      });
    }
  }, [majorValue]);

  
  const addRemarkForInvoice = (value, index) => {
    dispatch(
      fetchAsyncAddInvoicePurchaseRemarks({
        id: editData._id,
        moduleId:moduleInfo?._id,
        remarkData: { remark: value, index },
      })
    ).then((res) => {
      setMultipleInvoiceData(res?.payload?.updatedInvoice?.pyInfo?.inv);

      refreshEditData();
    });
  };

  const handleAmountApproveBtn = (values) => {
    if (!isEdit) {
      if (
        (!selectedBank && !!bankOptions?.length) ||
        (isInv && !dueDate) ||
        (isProforma && !proformaDueDate) ||
        (paymentStatus === 0 && !clientValue) ||
        !minorTypeValue ||
        (paymentStatus === 0 && !projectValue) ||
        !majorValue ||
        (minorSubCategoryOption &&
          minorSubCategoryOption?.length &&
          !minorSubCategoryValue)
      ) {
        setErrors({
          ...errors,
          projectValue: paymentStatus === 0 ? prJson.required.project : "",
          minorTypeValue: prJson.required.minorType,
          selectedBank: prJson.required.selectedBank,
          majorValue: prJson.required.majorType,
          dueDate: prJson.required.dueDate,
          proformaDueDate: prJson.required.proformaDueDate,
          invoiceDate: prJson.required.invoiceDate,
          proformaDate: prJson.required.proformaDate,
          clientValue: paymentStatus === 0 ? prJson.required.clientName : "",
          minorSubCategoryValue:
            minorSubCategoryOption && minorSubCategoryOption?.length
              ? prJson.required.minorSub
              : "",
        });
        addToast(prJson.required.allField, { appearance: "error" });
        return;
      }
    }
   
    if (isCredit) {
      const creditError = addCreditAmountValidate(
        multipleCredit,
        totalCreditAmount
      );
      if (Object.keys(creditError).length !== 0) {
        setCreditError(creditError);
        if (activeTab && activeTab !== "credit") {
          addToast(prJson.error.checkCredit, { appearance: "error" });
        }
        return;
      }
      const amount = parseFloat(totalPaymentAmount) - parseFloat(creditAmount);
      if (amount < 0) {
        addToast(prJson.error.invalidCredit, { appearance: "error" });
        return;
      }
      if (!creditValid) {
        return;
      }
    }

    let formData = getFormData(values);

    formData.append("isCredit", isCredit);
    const filteredMultipleCredit = multipleCredit.filter((item) => item?.usAmt);
    formData.append("creditInfo", JSON.stringify(filteredMultipleCredit));
    const filteredMultipleItemData = multipleItemList.filter(
      (item) => item?.slItm?._id
    );
    formData.append("itemInfo", JSON.stringify(filteredMultipleItemData));

    setIsLoading(true);

    if (isEdit && editData) {
        dispatch(
          fetchAsyncReSendRequestForApproval({
            id: editData._id,
            formData: formData,
            moduleId:moduleInfo?._id
          })
        )
          .then((res) => {
            if (res.payload && res.payload.updatedData) {
              const msg = prJson.confirm.resendRequest.replace(
                "{generatedNum}",
                isInv ? generatedNum : generatedPfiNum
              );
              setPaymentStatus(0);
              addToast(msg, { appearance: "success" });
              setIsLoading(false);
              closeModal("pending");
            } else {
              addToast(res?.error.message, { appearance: "error" });
              setIsLoading(false);
            }
          })
          .catch((err) => {
            addToast(err.message, { appearance: "error" });
            setIsLoading(false);
          });
      
    } else {
      dispatch(fetchAsyncSendRequestForApproval({moduleId:moduleInfo?._id,formData}))
        .then((res) => {
          if (res.payload) {
            const msg = prJson.confirm.sendRequest.replace(
              "{generatedNum}",
              isInv ? generatedNum : generatedPfiNum

            );
            addToast(msg, { appearance: "success" });
            setPaymentStatus(0);
            setIsLoading(false);
            closeModal("pending");
          } else {
            addToast(res?.error.message, { appearance: "error" });
            setIsLoading(false);
          }
        })
        .catch((err) => {
          addToast(err.message, { appearance: "error" });
          setIsLoading(false);
        });
    }
  };
  const handleTotalPayAmountIsApproved = (values) => {
    if (isEdit) {
      if (
        (!selectedBank && !!bankOptions?.length) ||
        (isInv && !dueDate) ||
        (isProforma && !proformaDueDate) ||
        (paymentStatus === 0 && !clientValue) ||
        !minorTypeValue ||
        (paymentStatus === 0 && !projectValue) ||
        !majorValue ||
        (minorSubCategoryOption &&
          minorSubCategoryOption?.length &&
          !minorSubCategoryValue)
      ) {
        setErrors({
          ...errors,
          projectValue: paymentStatus === 0 ? prJson.required.project : "",
          minorTypeValue: prJson.required.minorType,
          selectedBank: prJson.required.selectedBank,
          majorValue: prJson.required.majorType,
          dueDate: prJson.required.dueDate,
          proformaDueDate: prJson.required.proformaDueDate,
          invoiceDate: prJson.required.invoiceDate,
          proformaDate: prJson.required.proformaDate,
          clientValue: paymentStatus === 0 ? prJson.required.clientName : "",
          minorSubCategoryValue:
            minorSubCategoryOption && minorSubCategoryOption?.length
              ? prJson.required.minorSub
              : "",
        });
        addToast(prJson.required.allField, { appearance: "error" });
        return;
      }
    }
    if (parseFloat(creditAmount) > parseFloat(totalCreditAmount)) {
      setErrors({
        ...errors,
        creditAmount: prJson.error.creditLimit,
      });
    }
    let formData = getFormData(values);
    const _id = editData._id;

    if (isCredit) {
      const creditError = addCreditAmountValidate(
        multipleCredit,
        totalCreditAmount
      );
      if (Object.keys(creditError).length !== 0) {
        setCreditError(creditError);
        if (activeTab && activeTab !== "credit") {
          addToast(prJson.error.checkCredit, { appearance: "error" });
        }
        return;
      }
      const amount = parseFloat(totalPaymentAmount) - parseFloat(creditAmount);

      if (amount < 0) {
        addToast(prJson.error.invalidCredit, { appearance: "error" });
        return;
      }
      if (!creditValid) {
        return;
      }
    }

    formData.append("isCredit", isCredit);
    const filteredMultipleCredit = multipleCredit.filter((item) => item?.usAmt);
    formData.append("creditInfo", JSON.stringify(filteredMultipleCredit));

    const filteredMultipleItemData = multipleItemList.filter(
      (item) => item?.slItm?._id
    );
    formData.append("itemInfo", JSON.stringify(filteredMultipleItemData));

    if (editData.pyInfo?.sts === 0) {
      const confirmMsg = invJson.confirm.approveAmt;
      const currencySymbol = currency?.symbol || "₹";
      const formattedAmount = formatAmountIndianRupees(approvedAmount);
      const amount = `${currencySymbol} ${formattedAmount}`;
      const title = confirmMsg
        .replace("{approvalAmount}", amount)
        .replace("{generatedNum}", isInv ? generatedNum : generatedPfiNum);
      ConfirmationDialog({
        title: title,
        text: prJson.confirm.approveAction,
        icon: "warning",
        confirmButtonText: "Approve",
        cancelButtonText: "Cancel",
        onConfirm: () => {
          setIsLoading(true);
          dispatch(
            fetchAsyncApproveInvoiceAmount({
              id: _id,
              formData: formData,
              moduleId: moduleInfo?._id,
            })
          ).then((res) => {
            if (res.payload && res.payload.updatedData) {
              const msg = prJson.success.approved.replace(
                "{generatedNum}",
                isInv ? generatedNum : generatedPfiNum
              );
              addToast(msg, { appearance: "success" });
              setIsLoading(false);
              closeModal("approved");
            }
          });
        },
      });
    }
  };

  const handleTotalPayAmountIsRejected = () => {
    const _id = editData._id;
    let formData = new FormData();

    formData.append("isCredit", isCredit);
    const filteredMultipleCredit = multipleCredit.filter((item) => item?.usAmt);
    formData.append("creditInfo", JSON.stringify(filteredMultipleCredit));
    formData.append("totalPayAmountIsRejected", true);
    formData.append("approveRejectRemarks", approveOrRejectRemarks);

    if (editData.pyInfo?.sts === 0) {
      const confirmMsg = invJson.confirm.rejectAmt;
      const currencySymbol = currency?.symbol || "₹";
      const formattedAmount = formatAmountIndianRupees(approvedAmount);
      const amount = `${currencySymbol} ${formattedAmount}`;
      const title = confirmMsg
        .replace("{approvalAmount}", amount)
        .replace("{generatedNum}", isInv ? generatedNum : generatedPfiNum
        );
      ConfirmationDialog({
        title: title,
        text: prJson.confirm.rejectAction,
        icon: "warning",
        confirmButtonText: "Reject",
        cancelButtonText: "Cancel",
        onConfirm: () => {
          setIsLoading(true);
          dispatch(
            fetchAsyncRejectInvoiceAmount({
              id:_id,
              formData:formData,
              moduleId:moduleInfo?._id
            })
          ).then((res) => {
            if (res.payload && res.payload.updatedData) {
              const msg = prJson.success.rejected.replace(
                "{generatedNum}",
                isInv ? generatedNum : generatedPfiNum
              );
              addToast(msg, { appearance: "success" });
              closeModal("rejected");
              setIsLoading(false);
            }
          });
        },
      });
    }
  };

  const closeModelForm = () => {
    ConfirmationDialog({
      title: commonJson.close.confirm,
      text: commonJson.text.lost,
      icon: "warning",
      confirmButtonText: "Close",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        closeModal();
      },
    });
  };

  const handleRemarksChange = (e) => {
    const value = e?.target?.value;
    const encoder = new TextEncoder();
    const byteLength = encoder.encode(value).length;
    if (byteLength <= 128) {
      setRemarksValue(value);
      setErrors({
        ...errors,
        remarks: "",
      });
    } else {
      setErrors({
        ...errors,
        remarks: prJson.error.remarksLimit,
      });
    }
  };

  const handleCustomerNotesChange = (e) => {
    const value = e?.target?.value;
    const encoder = new TextEncoder();
    const byteLength = encoder.encode(value).length;
    if (byteLength <= 128) {
      setCustomerNotes(value);
      setErrors({
        ...errors,
        customerNotes: "",
      });
    } else {
      setErrors({
        ...errors,
        customerNotes: prJson.error.remarksLimit,
      });
    }
  };

  const deleteMultipleRefundListItem = (listIndex) => {
    ConfirmationDialog({
      title: prJson.confirm.deleteRefundAmt,
      text: "",
      icon: "warning",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        const sendData = {
          id: editData._id,
          moduleId:moduleInfo?._id,
          listIndex: listIndex,
        };
        dispatch(fetchAsyncDeleteRefundItem(sendData)).then(
          (res) => {
            if (
              res?.payload?.invoiceOrder?.rfdInfo?.list &&
              res?.payload?.invoiceOrder?.rfdInfo?.list?.length
            ) {
              setRefundRecords(
                res?.payload?.invoiceOrder?.rfdInfo?.list
              );
            } else {
              setRefundRecords((prevState) =>
                prevState.filter((_, i) => i !== listIndex)
              );
            }
            addToast(prJson.success.deleteRefund, { appearance: "success" });
          }
        );
      },
    });
  };

  const hasAccess = useCallback(() => {
    return (
      (role === "Admin" || role === "Manager" || role === "Accountant") &&
      paymentStatus === 1
    );
  }, [role, paymentStatus]);


  const isCreditAmountMismatch = useCallback(() => {
    return creditAmountMismatch(multipleCredit, editData);
  }, [multipleCredit, editData]);

  const isTaxableAmountMismatch = useCallback(() => {
    const existAmount = editData?.pyInfo?.txAmt || 0
    return parseFloat(taxableAmount) !== parseFloat(existAmount)
  }, [taxableAmount, editData]);

  const isRequestedAmountMismatch = useCallback(() => {
    const existAmount = editData?.pyInfo?.apAmt || 0
    return parseFloat(requestedAmount) !== parseFloat(existAmount)
  }, [requestedAmount, editData]);

  const isSendRequest = useCallback(() => {
    const isPending = paymentStatus === 0;
    return isTaxableAmountMismatch() || isRequestedAmountMismatch() || isCreditAmountMismatch() || isPending;
  }, [isTaxableAmountMismatch,isRequestedAmountMismatch, isCreditAmountMismatch,paymentStatus]);

  const updateCreditOptions = async () => {
    const creditIds = multipleCredit.map((item) => {
      if (item?.crId) {
        return item?.crId?._id;
      } else {
        return item?._id;
      }
    });
    const creditList = allCreditData.filter(
      (item) => !creditIds.includes(item?._id)
    );
    const creditOption = await clientProjectOptions("coNo", "_id", creditList);

    setAllCreditOptions(creditOption);
  };
  useEffect(() => {
    if (multipleCredit) {
      const sumOfCredit = calculateTotalCredit(multipleCredit);
      setCreditAmount(sumOfCredit);
      updateCreditOptions();
    }
  }, [multipleCredit, allCreditData]);

  const handleToggleCreditApplicable = () => {
    if (!clientValue) {
      addToast(prJson.required.clientName, { appearance: "error" });
    } else {
      if (!multipleCredit.length) {
        if (allCreditData.length > 0) {
          setIsCredit(!isCredit);
          const firstItem = allCreditData[0];

          const availableCredit =
            parseFloat(firstItem?.amt || 0) -
            parseFloat(firstItem?.usAmt || 0) -
            parseFloat(firstItem?.resAmt || 0);

          const remainingPayable = Math.max(totalReceivableAmt, 0);

          const defaultCredit = Math.min(availableCredit, remainingPayable);
          const obj = {
            ...firstItem,
            usAmt: defaultCredit,
          };
          setMultipleCredit([obj]);
        } else {
          addToast(prJson.error.avalClientCredit, { appearance: "error" });
        }
      } else {
        addToast(prJson.info.deleteCredit, { appearance: "info" });
      }
    }
  };

  const handleToggleRefundApplicable = () => {
    setIsRefund(!isRefund);
    if (!refundRecords?.length) {
      setRefundRecords([""]);
    }
  };

  const handleSelectTab = (k) => {
    setActiveTab(k);
  };

  const getAllCreditByClientID = async (clientId) => {
    try {
      const res = await dispatch(
        fetchAsyncGetCreditOptionsByClientId(clientId)
      );
      if (res?.payload) {
        const creditDetail = res?.payload?.filterCredit;
        const total = res?.payload?.totalAmount;

        const filterCredit = creditDetail?.map((item) => {
          return {
            ...item,
            coNo: poNumberFormate(item?.crNo),
          };
        });
        const creditOption = await clientProjectOptions(
          "coNo",
          "_id",
          filterCredit
        );
        setAllCreditData(filterCredit);
        setTotalCreditAmount(total);
        setAllCreditOptions(creditOption);
        setIsLoading(false);
        if (!isEdit) {
          setMultipleCredit([]);
          setIsCredit(false);
        }
      }
    } catch (error) {
      setIsLoading(false);
      addToast(prJson.error.fetchCredit, { appearance: "error" });
    }
  };
  const handleAddCredit = (newValue) => {
    const creditId = newValue?.value;
    const creditData = allCreditData || [];
    const newItem = creditData?.find((item) => item._id === creditId);
      
    const availableCredit =
      parseFloat(newItem?.amt || 0) -
      parseFloat(newItem?.usAmt || 0) -
      parseFloat(newItem?.resAmt || 0);

    const remainingPayable = Math.max(totalReceivableAmt, 0);

    const defaultCredit = Math.min(
      availableCredit,
      remainingPayable
    );

    const obj = {
      ...newItem,
      usAmt: defaultCredit,
    };
    setMultipleCredit([...multipleCredit, obj]);
    setAddCredit(!addCredit);
  };

  const validateCredits = useCallback(() => {
    return isValidateCredit(multipleCredit, editData);
  }, [multipleCredit]);

  const handleDeleteCredit = (id, creditId) => {
    ConfirmationDialog({
      title: prJson.confirm.deleteCredit,
      text: "",
      icon: "warning",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        setIsLoading(true);
        if (creditId && creditId?._id) {
          const data = {
            creditId: id,
            moduleId:moduleInfo?._id,
            expenseId: editData?._id,
            status: paymentStatus === 1 ? "approved" : "pending",
            expenseType: expenseType,
          };
          dispatch(fetchAsyncDeleteCreditListItem(data))
            .then((res) => {
              if (res?.payload) {
                refreshEditData();
                const filterCredit = multipleCredit.filter(
                  (item) => item?.crId?._id !== id
                );

                setMultipleCredit(filterCredit);
                if (filterCredit.length === 0) {
                  setIsCredit(!isCredit);
                }
                addToast(prJson.success.deletedCredit, {
                  appearance: "success",
                });
                setIsLoading(false);
              } else {
                addToast(prJson.faield.deleteCredit, { appearance: "error" });
                setIsLoading(false);
                const clientId = clientValue.value;
                getAllCreditByClientID(clientId);
              }
            })
            .catch((err) => {
              addToast(prJson.faield.deleteCredit, { appearance: "error" });
              setIsLoading(false);
            });
        } else {
          const filterCredit = multipleCredit.filter((item) => item._id !== id);
          setMultipleCredit(filterCredit);
          if (filterCredit.length === 0) {
            setIsCredit(!isCredit);
          }
          setIsLoading(false);
          addToast(prJson.success.deleteCredit, { appearance: "success" });
          const clientId = clientValue.value;
          getAllCreditByClientID(clientId);
        }
      },
    });
  };

  const handleRemoveSelectedItem = (index) => {
    const updatedData = multipleItemList.map((data, i) => {
      const obj = { ...data };
      if (i === index) {
        obj.slItm = {};
        obj.prc = 0;
        obj.qty = 1;
        obj.tax = {};
        obj.amt = 0;
       
        return obj;
      } else {
        return data;
      }
    });
    setMultipleItemList(updatedData);
  };
  const handleMultipleListItem = (item, index) => {
    const updatedData = multipleItemList.map((data, i) => {
      const obj = { ...data };
      const istr = item?.istr?.id
        ? item.istr
        : taxOptions.find((opt) => opt?.id === item?.istr);
      if (i === index) {
        obj.slItm = item;
        obj.prc = Number(item?.prc) || 0;
        obj.tax = currency?.code === 'INR' ? (istr || {}) : {};
        obj.amt = Number(obj.qty) * obj.prc;

        return obj;
      } else {
        return data;
      }
    });

    setMultipleItemList(updatedData);
  };

  const handleUpdateItemField = (value, name, index) => {
    const updatedData = multipleItemList.map((data, i) => {
      const obj = { ...data };
      if (i === index) {
        if (name === "description") {
          const obj1 = {
            ...data.slItm,
            dc: value,
          };
          obj.slItm = obj1;
        } else if (name === "hsnCode") {
          const obj1 = {
            ...data.slItm,
            hCd: value,
          };
          obj.slItm = obj1;
        } else if (name === "sacCode") {
          const obj1 = {
            ...data.slItm,
            sCd: value,
          };
          obj.slItm = obj1;
        } else if (name === "quantity") {
          obj.qty = Number(value) || 0;
        } else if (name === "rate") {
          obj.prc = Number(value) || 0;
        } else if (name === "tax") {
          obj.tax = currency?.code === "INR" ? (value || {}) : {};
        }

        obj.amt = obj.qty * obj.prc;

        return { ...obj };
      } else {
        return data;
      }
    });

    setMultipleItemList(updatedData);
  };
  const handleUpdateListItem = (item, index) => {
    const updatedData = multipleItemList.map((data, i) => {
      if (i === index) {
        const qty = Number(data.qty) || 0;
        const prc = Number(item?.sellingPrice) || 0;
        return {
          ...item,
          qty,
          prc,
          amt: qty*prc,
          dc: item?.description,
          tax: currency?.code === "INR" ? (item?.interStateTaxRate || {}) : {},
          slItm: {
            cId:clientValue?.value,
            cur:item?.currency?.code,
            dc:item?.description,
            hCd:item?.hsnCode,
            isDs:item?.isDigitalService,
            istr:item?.interStateTaxRate?.id,
            name:item?.name,
            prc:item?.sellingPrice,
            sCd:item?.sacCode,
            typ:item?.type,
            unt:item?.unit?.id,
            _id:item?._id
          }
        }
      } else {
        return data;
      }
    });
    setMultipleItemList(updatedData);
  };
  const handleAddRow = () => {
    const data = [...multipleItemList];
    data.push({
      slItm: {},
      qty: 1,
      prc: "",
      tax: {},
      amt: 0,
    });
    setMultipleItemList(data);
  };
  const handleDeleteRow = (e, index) => {
    ConfirmationDialog({
      title: prJson.confirm.deleteItem,
      text: "",
      icon: "warning",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        e.preventDefault();
        const updatedFields = multipleItemList.filter((_, i) => i !== index);
        setMultipleItemList(updatedFields);
      },
    });
  };

  const isGstApplicable = (gstFullData) => {
    const { amt } = gstFullData;

    const igstExists = amt?.i && amt?.i !== 0;
    const cgstExists = amt?.c && amt?.c !== 0;
    const sgstExists = amt?.s && amt?.s !== 0;

    return igstExists || cgstExists || sgstExists;
  };
  const handleUpdateMultipleGstData = async (gstData, index) => {
    const updatedData = {
      bsAmt: gstData?.bsAmt,
      gstNo: gstData?.gstNo,
      amt: gstData?.amt || {},
    };

    const updateList = gstRecords.map((item, i) => {
      if (i === index) {
        return { ...item, ...updatedData };
      } else return item;
    });
    const gstApplicable = isGstApplicable(updatedData);
    if(gstApplicable){
      setGstRecords([...updateList]);
    }
    else{
      setGstRecords([])
    }
  };
  const handleCurrency = (newValue) => {
    const hasAmount = multipleItemList.some(item => item.amt);
    
    if (hasAmount) {
      ConfirmationDialog({
        title: "Changing currency will clear your existing items.",
        text: "Are you sure you want to proceed?",
        icon: "warning",
        confirmButtonText: "Continue",
        cancelButtonText: "Cancel",
        onConfirm: () => {
          setMultipleItemList([
            {
              slItm: {},
              qty: 1,
              prc: "",
              tax: {},
              amt: 0,
            },
          ]);
          setCurrency(newValue);
        },
      });
    } else {
      setCurrency(newValue);
    }
  };

  useEffect(() => {
    if (!isFormDataSetRef.current) return;

    // custom mode => manual handling only
    if (termsValue?.value === -1) return;

    const daysToAdd = parseInt(termsValue?.value || 0);

    // auto calculate invoice due date
    if (isInv && invoiceDate) {
      const newDueDate = moment(invoiceDate)
        .add(daysToAdd, "days")
        .toDate();

      setDueDate(newDueDate);
    } else {
      setDueDate(null);
    }

    // auto calculate proforma due date
    if (isProforma && proformaDate) {
      const newProformaDueDate = moment(proformaDate)
        .add(daysToAdd, "days")
        .toDate();

      setProformaDueDate(newProformaDueDate);
    } else {
      setProformaDueDate(null);
    }
  }, [
    invoiceDate,
    proformaDate,
    termsValue,
    isInv,
    isProforma,
  ]);

  const handlePaymentTerms = (newValue)=>{
    setTermsValue(newValue);
    
  }
  const handleItemAmount = (amount) => {
    setTotalPaymentAmount(amount?.totalAmt);
    setTaxableAmount(amount?.taxable);
    setRequestedAmount(amount?.requested)


  };

  const handleInvoiceSetting = (data)=>{
    setInvPrefix({
      ...invPrefix,
      n:data.nextNumber
    })
    setInvoiceMode(data.invoiceMode)
  }
  const handleProformaSetting = (data)=>{
    setPfiPrefix({
      ...pfiPrefix,
      n:data.nextNumber
    })
    setProformaMode(data.proformaMode)
  }

  const handleAddPaymentRecords = (data) => {
    setPaymentRecords([
      ...paymentRecords,
      {dt:new Date()},
    ]);
  };

  const handleOnChangePaymentRecord = async (name,value, index) => {
    const updateList = paymentRecords.map((item, i) => {
      if (i === index) {
        return { ...item,[name]:value};
      } else return item;
    });
    const recordError = RecordPaymentValidate(
      updateList,
    );
    if (recordError) {
      setPaymentRecordsError(recordError)
    }
    setPaymentRecords(updateList || []);
  };

  const removePaymentRecord = (index) => {
    setPaymentRecords(prevState => prevState.filter((_, i) => i !== index));
  }
  const deletePaymentRecord = (item,index)=>{
    if(item?._id){
      ConfirmationDialog({
        title: prJson.confirm.deleteAmt,
        text: '',
        icon: 'warning',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        onConfirm: () => {
          dispatch(fetchAsyncDeletePaymentRecord({moduleId:moduleInfo?._id,id:item?._id})).then((res) => {
            if(res.payload){
              removePaymentRecord(index);
              refreshEditData();
              addToast('Payment Record Deleted!', { appearance: "success" });
            }
            else{
              addToast('Failed to delete payment record', { appearance: "error" });
            }
          });
        }
      });
    }
    else{
      removePaymentRecord(index)
    }
  }
 
  const handleToggleTDSDeducted = () => {
    const tdsArray = tdsRecords.filter(item => {
      if(item?._id){
      return item?._id
    } 
    })
    if (tdsArray?.length) {
      addToast(`first for delete existing tds records!`,{ appearance: "info" });
    } else {
      setIsTds(!isTds)
      if(!tdsRecords?.length){
        setTdsRecords([{}])
      }
    }
  };
  const handleAddTdsRecords = (data) => {
    setTdsRecords([
      ...tdsRecords,
      {},
    ]);
  };

  const handleOnChangeTdsRecord = async (name,value, index) => {
    const updateList = tdsRecords.map((item, i) => {
      if (i === index) {
        const updatedItem = { ...item, [name]: value };
      if (name === 'bsAmt' || name === 'prc') {
        const bsAmt = updatedItem.bsAmt || 0; 
        const prc = updatedItem.prc || 10; 
        const tdsAmt = (bsAmt * prc) / 100; 
        updatedItem.tdsAmt = tdsAmt;
      }
      if(!updatedItem?.prc){
        updatedItem.prc = 10
      };
      return updatedItem;
      } else return item;
    });
    
    setTdsRecords(updateList || []);
  };

  const removeTDSRecord = (index) => {
    setTdsRecords(prevState => {
      const updatedRecords = prevState.filter((_, i) => i !== index);
      if (updatedRecords.length === 0) {
        setIsTds(false); 
      }
      return updatedRecords;
    });
  }
  const deleteTdsRecord = (item,index)=>{
    if(item?._id){
      ConfirmationDialog({
        title: `Are you sure? Delete Tds Amount Details Permanently?`,
        text: '',
        icon: 'warning',
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        onConfirm: () => {
          dispatch(fetchAsyncDeleteTdsRecord({moduleId:moduleInfo?._id,id:item?._id})).then((res) => {
            if(res.payload){
              removeTDSRecord(index);
              refreshEditData();
              addToast('TDS Record Deleted!', { appearance: "success" });
            }
            else{
              addToast('Failed to delete tds record', { appearance: "error" });
            }
          });
        }
      });
    }
    else{
      removeTDSRecord(index)
    }
  }

  const handleChangeTaxInvoiceDate = (date) => {
    // invoice date >= proforma date
    if (
      date &&
      isProforma &&
      proformaDate &&
      moment(date).isBefore(proformaDate, "day")
    ) {
      setProformaDate(null);
      setProformaDueDate(null);
    }

    // custom mode only
    if (termsValue?.value === -1) {
      if (date) {
        // preserve custom gap
        if (invoiceDate && dueDate) {
          const diffDays = moment(dueDate).diff(
            invoiceDate,
            "days"
          );

          const newDueDate = moment(date)
            .add(diffDays, "days")
            .toDate();

          // invoice due date >= invoice date
          if (
            moment(newDueDate).isSameOrAfter(date, "day")
          ) {

            // invoice due date >= proforma due date
            if (
              proformaDueDate &&
              moment(newDueDate).isBefore(
                proformaDueDate,
                "day"
              )
            ) {
              setProformaDueDate(null);
            }
            setDueDate(newDueDate);
          } else {
            setDueDate(null);
          }
        }
      }
    }
    setInvoiceDate(date);
  };

  const handleChangeProformaInvoiceDate = (date) => {
    // invoice date >= proforma date
    if (
      date &&
      invoiceDate &&
      moment(invoiceDate).isBefore(date, "day")
    ) {
      setInvoiceDate(null);
      setDueDate(null);
    }

    // custom mode only
    if (termsValue?.value === -1) {
      if (date) {
        // preserve custom gap
        if (proformaDate && proformaDueDate) {
          const diffDays = moment(
            proformaDueDate
          ).diff(proformaDate, "days");

          const newProformaDueDate = moment(date)
            .add(diffDays, "days")
            .toDate();

          const newProformaDueDateMoment = moment(newProformaDueDate)
          // proforma due date >= proforma date || proforma due date <= invoice due date
          if (
            newProformaDueDateMoment.isAfter(dueDate) ||
            newProformaDueDateMoment.isBefore(date,"day")
          ) {
            setProformaDueDate(null);
          } else {
            setProformaDueDate(newProformaDueDate);
          }
        }
      }
    }

    setProformaDate(date);
  };

  const handleChangeInvoiceDueDate = (date) => {
    // disabled in non-custom mode
    if (termsValue?.value !== -1) return;

    // invoice due date >= invoice date
    if (
      date &&
      invoiceDate &&
      moment(date).isBefore(invoiceDate, "day")
    ) {
      return;
    }

    // invoice due date >= proforma due date
    if (
      date &&
      proformaDueDate &&
      moment(date).isBefore(
        proformaDueDate,
        "day"
      )
    ) {
      setProformaDueDate(null);
    }

    setDueDate(date);
  };

  const handleChangeProformaInvoiceDueDate = (date) => {
    // disabled in non-custom mode
    if (termsValue?.value !== -1) return;

    // proforma due date >= proforma date
    if (
      date &&
      proformaDate &&
      moment(date).isBefore(proformaDate, "day")
    ) {
      return;
    }

    // invoice due date >= proforma due date
    if (
      isInv &&
      date &&
      dueDate &&
      moment(dueDate).isBefore(date, "day")
    ) {
      return;
    }

    setProformaDueDate(date);
  };

  const handleToggleGenerateInvoice = () => {
      const title = `Are you sure you want to convert this proforma invoice to a invoice?`;
      ConfirmationDialog({
        title: title,
        text: "This action cannot be undone.",
        icon: 'warning',
        confirmButtonText: 'Convert',
        cancelButtonText: 'Cancel',
        onConfirm: () => {
          setIsInv(true)
          fetchNextInvoiceNumber()
          setInvoiceDate(new Date())
        },
      });
  };
  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={openModal}
        onClose={() => closeModelForm()}
        size="xl"
        className="modal-main"
      >
        <ModalOverlay />
        <ModalContent
          top="0" // Position it at the top
          margin="0 auto" // Center it horizontally
          bottom="0"
          className="add-form-modal-content"
        >
          <div className="fixed-header">
            <ModalHeader className="expense-modal-header">
              {isInv ? "Tax" : "Proforma"} Invoice -{" "}
              <span className="header-pr">
                {isInv ? generatedNum : generatedPfiNum}
              </span>
            </ModalHeader>
            <ModalCloseButton />
          </div>
          {isLoading ? (
            <SpinnerLoader />
          ) : (
            <ModalBody>
              <Form className="addForm" onSubmit={formik.handleSubmit}>
                <div className="form-card">
                  {isProforma && (
                    <>
                    <Row className="mt-2">
                      <h5 className="mb-2">Proforma Details</h5>
                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>
                            <span className="span-star">Proforma Number#</span>
                          </Form.Label>
                          <InputGroup className="input-group">
                            <Form.Control
                              type="text"
                              name="pfiNo"
                              value={generatedPfiNum && generatedPfiNum}
                              disabled
                            />
                            {!isEdit && (
                              <InputGroup.Text>
                                <Tooltip
                                  label="Click her to enable or disable auto-generation of proforma invoice number."
                                  placement="top"
                                  hasArrow
                                  fontSize="13px"
                                  className="common-tooltip"
                                >
                                  <SettingOutlined
                                    size={18}
                                    style={{ color: "blue" }}
                                    onClick={(e) =>
                                      setIsPfSetting(!isPfSetting)
                                    }
                                  />
                                </Tooltip>
                              </InputGroup.Text>
                            )}
                          </InputGroup>
                        </Box>
                      </Col>

                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>
                            Proforma Date <span className="span-star">*</span>
                          </Form.Label>
                          <Box>
                            <DatePicker
                              name="proformaDate"
                              className={`monthDate`}
                              maxDate={isInv ? invoiceDate : undefined}
                              dateFormat="dd-MMM-yyyy"
                              onChange={handleChangeProformaInvoiceDate}
                              selected={proformaDate}
                              showMonthDropdown={true}
                              showYearDropdown={true}
                              dropdownMode="select"
                            />
                          </Box>
                        </Box>

                        {errors?.proformaDate &&
                          !proformaDate && (
                            <p className="form_error">
                              {errors?.proformaDate}
                            </p>
                          )}
                      </Col>
                    </Row>
                    <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>Proforma Due Date <span className="span-star">*</span></Form.Label>
                        <Box>
                          <DatePicker
                            name="proformaDueDate"
                            minDate={proformaDate}
                            maxDate={isInv ? dueDate : undefined}
                            className={`monthDate`}
                            dateFormat="dd-MMM-yyyy"
                            onChange={handleChangeProformaInvoiceDueDate}
                            selected={proformaDueDate}
                            showMonthDropdown={false}
                            showYearDropdown={false}
                            dropdownMode="select"
                            disabled={termsValue?.value !== -1}
                          />
                        </Box>
                      </Box>

                      {errors?.proformaDueDate &&
                        !proformaDueDate && (
                          <p className="form_error">
                            {errors?.proformaDueDate}
                          </p>
                        )}
                    </Col><Col></Col></Row></>
                  )}
                  {isInv && (
                    <>
                    <Row className="mt-2">
                      <h5 className="mb-2">Invoice Details</h5>
                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>
                            <span className="span-star">Invoice Number# </span>
                          </Form.Label>
                          <InputGroup className="input-group">
                            <Form.Control
                              type="text"
                              name="invNo"
                              value={generatedNum && generatedNum}
                              disabled
                            />
                            {!editData?.isInv && (
                              <InputGroup.Text>
                                <Tooltip
                                  label="Click her to enable or disable auto-generation of invoice number."
                                  placement="top"
                                  hasArrow
                                  fontSize="13px"
                                  className="common-tooltip"
                                >
                                  <SettingOutlined
                                    size={18}
                                    style={{ color: "blue" }}
                                    onClick={(e) => setIsSetting(!isSetting)}
                                  />
                                </Tooltip>
                              </InputGroup.Text>
                            )}
                          </InputGroup>
                        </Box>
                      </Col>

                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>
                            Invoice Date <span className="span-star">*</span>
                          </Form.Label>
                          <Box>
                            <DatePicker
                              name="invoiceDate"
                              className={`monthDate`}
                              dateFormat="dd-MMM-yyyy"
                              onChange={handleChangeTaxInvoiceDate}
                              selected={invoiceDate && invoiceDate}
                              showMonthDropdown={true}
                              showYearDropdown={true}
                              dropdownMode="select"
                            />
                          </Box>
                        </Box>

                        {errors?.invoiceDate &&
                          !invoiceDate && (
                            <p className="form_error">
                              {errors?.invoiceDate}
                            </p>
                          )}
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>Invoice Due Date <span className="span-star">*</span></Form.Label>
                        <Box>
                          <DatePicker
                            name="dueDate"
                            minDate={invoiceDate}
                            className={`monthDate`}
                            dateFormat="dd-MMM-yyyy"
                            onChange={handleChangeInvoiceDueDate}
                            selected={dueDate}
                            showMonthDropdown={false}
                            showYearDropdown={false}
                            dropdownMode="select"
                            disabled={termsValue?.value !== -1}
                          />
                        </Box>
                      </Box>
                      {errors?.dueDate &&
                        !dueDate && (
                          <p className="form_error">
                            {errors?.dueDate}
                          </p>
                        )}
                    </Col>
                    <Col></Col>
                    </Row></>
                  )}

                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Invoice Currency{" "}
                          <span className={`span-star `}>*</span>
                        </Form.Label>
                        <CustomPopover popoverText="Select the currency type for this invoice" />
                        <CurrencySelectField
                          options={allCurrency}
                          placeHolder=""
                          defaultValue={currency}
                          isSearchable
                          onChange={(newValue) => handleCurrency(newValue)}
                        />
                      </Box>
                    </Col>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>Payment Terms</Form.Label>

                        <ClientProjectSelect
                          options={termsOptions}
                          placeHolder={<div>Type or select...</div>}
                          onChange={(newValue) => handlePaymentTerms(newValue)}
                          isSearchable
                          defaultValue={termsValue}
                          value={termsValue}
                          role={role}
                        />
                      </Box>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Box display="flex" className="input-box mt-1">
                        <Form.Label>Subject of Invoice</Form.Label>
                        <TextAreaField
                          name="invSubject"
                          value={invSubject}
                          handleChange={(e) => setInvSubject(e?.target?.value)}
                        />
                      </Box>
                    </Col>
                  </Row>
                </div>
                <Divider className="mt-3" />
                <div className="form-card mt-0">
                  <h5>Invoice Type</h5>
                  <Row>
                    <Col className="custom-select">
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Major Type <span className="span-star">*</span>
                        </Form.Label>

                        <CustomSelect
                          options={majorOptions}
                          placeHolder={<div>Type or select...</div>}
                          onChange={(newValue) => setMajorValue(newValue)}
                          isSearchable
                          onCreateOption={(e) => {
                            createNewFormOption(createOption(e), "expense");
                          }}
                          onDeleteOption={(option) => {
                            deleteFromOption(option, "expense");
                          }}
                          onEditOption={(option, newValue) => {
                            editFromOption(option, newValue, "expense");
                          }}
                          defaultValue={majorValue}
                          role={role}
                          isInvalid={errors?.majorValue && !majorValue}
                        />
                      </Box>
                      {errors?.majorValue && !majorValue && (
                        <p className="form_error">{errors?.majorValue}</p>
                      )}
                    </Col>
                    <Col className="custom-select">
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Minor Type <span className="span-star">*</span>
                        </Form.Label>

                        <CustomSelect
                          options={minorTypeOption}
                          placeHolder={<div>Type or select...</div>}
                          onChange={(newValue) => setMinorTypeValue(newValue)}
                          isSearchable
                          onCreateOption={(e) => {
                            if (majorValue?.value) {
                              createSubCategory(createOption(e), majorValue);
                            } else {
                              addToast("Please Select Major Type", {
                                appearance: "error",
                              });
                            }
                          }}
                          onDeleteOption={(option) => {
                            deleteSubCategory(option);
                          }}
                          onEditOption={(option, newValue) => {
                            editSubCategory(option, newValue);
                          }}
                          defaultValue={minorTypeValue}
                          role={role}
                          isInvalid={errors?.minorTypeValue && !minorTypeValue}
                        />
                      </Box>
                      {errors?.minorTypeValue && !minorTypeValue && (
                        <p className="form_error">{errors?.minorTypeValue}</p>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="custom-select">
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Minor Sub Category{" "}
                          <span className="span-star">
                            {minorSubCategoryOption &&
                            minorSubCategoryOption?.length
                              ? "*"
                              : ""}
                          </span>
                        </Form.Label>

                        <CustomSelect
                          options={minorSubCategoryOption}
                          placeHolder={<div>Type or select...</div>}
                          onChange={(newValue) =>
                            setMinorSubCategoryValue(newValue)
                          }
                          isSearchable
                          onCreateOption={(e) => {
                            if (minorTypeValue?.value) {
                              createMinorSubCategory(
                                createOption(e),
                                minorTypeValue
                              );
                            } else {
                              addToast("Please Select Minor Type", {
                                appearance: "error",
                              });
                            }
                          }}
                          onDeleteOption={(option) => {
                            deleteMinorSubCategory(option);
                          }}
                          onEditOption={(option, newValue) => {
                            editMinorSubCategory(option, newValue);
                          }}
                          defaultValue={minorSubCategoryValue}
                          role={role}
                          isInvalid={
                            errors?.minorSubCategoryValue &&
                            !minorSubCategoryValue
                          }
                        />
                      </Box>
                      {errors?.minorSubCategoryValue &&
                        !minorSubCategoryValue && (
                          <p className="form_error">
                            {errors?.minorSubCategoryValue}
                          </p>
                        )}
                    </Col>
                    <Col className="custom-select">
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Bank Name{" "}
                          <span className="span-star">
                            {bankOptions?.length
                              ? "*"
                              : ""}
                          </span>
                        </Form.Label>

                        <CustomSelect
                          options={bankOptions}
                          placeHolder={<div>Type or select...</div>}
                          onChange={(newValue) =>
                            setSelectedBank(newValue)
                          }
                          hideActions
                          isSearchable
                          defaultValue={selectedBank}
                          role={role}
                          // TODO: invalid when...
                          isInvalid={
                            errors?.selectedBank &&
                            !selectedBank
                          }
                        />
                      </Box>
                      {errors?.selectedBank &&
                        !selectedBank && (
                          <p className="form_error">
                            {errors?.selectedBank}
                          </p>
                        )}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Client Name{" "}
                          {paymentStatus === 0 && (
                            <span className="span-star">*</span>
                          )}
                        </Form.Label>
                        <div
                          className="merchant-field"
                          onMouseEnter={() => setIsHovered(true)}
                          onMouseLeave={() => setIsHovered(false)}
                        >
                          <ClientProjectSelect
                            options={clientOPtion}
                            placeHolder={<div>Type or select...</div>}
                            onChange={(newValue) => {
                              setClientValue(newValue);
                              setIsHovered(false);
                            }}
                            isSearchable
                            defaultValue={clientValue}
                            role={role}
                            isInvalid={errors?.clientValue && !clientValue}
                          />
                          {clientValue?.value &&
                          totalCreditAmount &&
                          isHovered ? (
                            <Form.Text className="text-muted credit-amount-popover">
                              <Box className="" display="flex">
                                <Box className="credit-amount-tag">
                                  {formatAmountInINR(totalCreditAmount || 0)}
                                </Box>
                              </Box>
                            </Form.Text>
                          ) : (
                            ""
                          )}
                        </div>
                      </Box>
                      {errors?.clientValue && !clientValue && (
                        <p className="form_error">{errors?.clientValue}</p>
                      )}
                    </Col>
                    <Col className="custom-select">
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Project Name <span className="span-star">*</span>
                        </Form.Label>

                        <ClientProjectSelect
                          options={projectOption}
                          placeHolder={<div>Type or select...</div>}
                          onChange={(newValue) => setProjectValue(newValue)}
                          isSearchable
                          defaultValue={projectValue}
                          role={role}
                          isInvalid={errors?.projectValue && !projectValue}
                        />
                      </Box>
                      {errors?.projectValue && !projectValue && (
                        <p className="form_error">{errors?.projectValue}</p>
                      )}
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Box
                        display="flex"
                        flexDirection="column"
                        className="input-box1"
                      >
                        <Form.Label>Remarks </Form.Label>
                        <TextAreaField
                          customClass="notes-textarea"
                          name="remarks"
                          rows={3}
                          value={remarksValue}
                          handleChange={(e) => handleRemarksChange(e)}
                          isInvalid={!!errors?.remarks}
                        />
                      </Box>
                      <p className="form_error">{errors?.remarks}</p>
                    </Col>
                    <Col>
                      <Box
                        display="flex"
                        flexDirection="column"
                        className="input-box1"
                      >
                        <Form.Label>
                          Customer Notes{" "}
                          <CustomPopover popoverText="Will be displayed on the invoice" />
                        </Form.Label>
                        <TextAreaField
                          customClass="notes-textarea"
                          name="customerNotes"
                          rows={3}
                          value={customerNotes}
                          handleChange={(e) => handleCustomerNotesChange(e)}
                          isInvalid={!!errors?.customerNotes}
                        />
                      </Box>
                      <p className="form_error">{errors?.customerNotes}</p>
                    </Col>
                  </Row>
                </div>
                <Divider className="mt-3" />
                <div className="form-card mt-3">
                  <Box display="flex" className="payment-info-box">
                    <h5>Payment Information</h5>
                  </Box>
                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Taxable Amount <span className="span-star">*</span>
                        </Form.Label>

                        <InputGroup className="input-group">
                          <InputGroup.Text>
                            <span className="rupee-symbol">
                              {currency?.symbol || "₹"}
                            </span>{" "}
                          </InputGroup.Text>
                          <CurrencyFormat
                            customInput={Form.Control}
                            className="amount-input"
                            type="text"
                            value={taxableAmount}
                            disabled
                            placeholder="0.00"
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale={true}
                          />
                        </InputGroup>
                      </Box>
                    </Col>

                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Requested Amount <span className="span-star">*</span>
                        </Form.Label>
                        <InputGroup className="input-group">
                          <InputGroup.Text>
                            <span className="rupee-symbol">
                              {currency?.symbol || "₹"}
                            </span>{" "}
                          </InputGroup.Text>
                          <CurrencyFormat
                            customInput={Form.Control}
                            className="amount-input"
                            type="text"
                            value={requestedAmount}
                            disabled
                            placeholder="0.00"
                            thousandSeparator={true}
                            decimalScale={2}
                            fixedDecimalScale={true}
                          />
                        </InputGroup>
                      </Box>
                    </Col>
                  </Row>

                  {paymentStatus === 1 && (
                    <>
                      <Row>
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>Approved Amount</Form.Label>
                            <InputGroup className="input-group">
                              <InputGroup.Text>
                                <span className="rupee-symbol">
                                  {currency?.symbol || "₹"}
                                </span>{" "}
                              </InputGroup.Text>
                              <CurrencyFormat
                                customInput={Form.Control}
                                className="amount-input"
                                type="text"
                                disabled
                                name="totalPayAmount"
                                placeholder="Total Amount"
                                value={approvedAmount}
                                thousandSeparator={true}
                                decimalScale={2}
                                fixedDecimalScale={true}
                              />
                            </InputGroup>
                          </Box>
                        </Col>
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>Credit Utilized</Form.Label>
                            <InputGroup className="input-group">
                              <InputGroup.Text>
                                <span className="rupee-symbol">
                                  {currency?.symbol || "₹"}
                                </span>{" "}
                              </InputGroup.Text>
                              <CurrencyFormat
                                customInput={Form.Control}
                                className="amount-input"
                                type="text"
                                disabled
                                name="creditAmount"
                                placeholder="Credit Amount"
                                value={creditAmount || 0}
                                thousandSeparator={true}
                                decimalScale={2}
                                fixedDecimalScale={true}
                              />
                            </InputGroup>
                          </Box>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>Net Receivable Amount</Form.Label>
                            <InputGroup className="input-group">
                              <InputGroup.Text>
                                <span className="rupee-symbol">
                                  {currency?.symbol || "₹"}
                                </span>{" "}
                              </InputGroup.Text>
                              <CurrencyFormat
                                customInput={Form.Control}
                                className="amount-input"
                                type="text"
                                value={totalReceivableAmt}
                                disabled
                                placeholder="0.00"
                                thousandSeparator={true}
                                decimalScale={2}
                                fixedDecimalScale={true}
                              />
                            </InputGroup>
                          </Box>
                          {totalReceivableAmt < 0 &&
                            approvedAmount <= requestedAmount && (
                              <p className="form_error">
                                Receivable Amount cannot be negative. Please
                                revise the request with an increased requested
                                amount and resubmit for approval.
                              </p>
                            )}
                        </Col>
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>Received Amount</Form.Label>
                            <InputGroup className="input-group">
                              <InputGroup.Text>
                                <span className="rupee-symbol">
                                  {currency?.symbol || "₹"}
                                </span>{" "}
                              </InputGroup.Text>
                              <CurrencyFormat
                                customInput={Form.Control}
                                type="text"
                                disabled
                                className="amount-input"
                                name="totalPayAmount"
                                placeholder="Total Amount"
                                value={totalReceivedAmount}
                                thousandSeparator={true}
                                decimalScale={2}
                                fixedDecimalScale={true}
                              />
                            </InputGroup>
                          </Box>
                        </Col>
                      </Row>
                    </>
                  )}

                  {paymentStatus !== 1 && (
                    <Row>
                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>Credit Utilized</Form.Label>
                          <InputGroup className="input-group">
                            <InputGroup.Text>
                              <span className="rupee-symbol">
                                {currency?.symbol || "₹"}
                              </span>{" "}
                            </InputGroup.Text>
                            <CurrencyFormat
                              customInput={Form.Control}
                              className="amount-input"
                              type="text"
                              disabled
                              name="creditAmount"
                              placeholder="Credit Amount"
                              value={creditAmount || ""}
                              thousandSeparator={true}
                              decimalScale={2}
                              fixedDecimalScale={true}
                            />
                          </InputGroup>
                        </Box>
                      </Col>
                      <Col></Col>
                    </Row>
                  )}
                </div>
                <div>
                  <Tabs
                    defaultActiveKey={activeTab ? activeTab : "items"}
                    transition={false}
                    id="noanim-tab-example"
                    className="add-form-tabs expense-tabs mt-0"
                    onSelect={handleSelectTab}
                  >
                    <Tab
                      eventKey="items"
                      title={<div className="d-flex ">Items</div>}
                      className="add-form-tab"
                    >
                      {activeTab === "items" && (
                        <div className="form-card mt-0">
                          <Box>
                            <div>
                              <AddItemComponent
                                itemList={multipleItemList}
                                gstRecords={gstRecords}
                                handleListItem={(item, index) =>
                                  handleMultipleListItem(item, index)
                                }
                                handleAddRow={() => handleAddRow()}
                                handleDeleteRow={(e, index) =>
                                  handleDeleteRow(e, index)
                                }
                                handleRemoveSelectedItem={(index) =>
                                  handleRemoveSelectedItem(index)
                                }
                                handleUpdateList={(item, index) =>
                                  handleUpdateListItem(item, index)
                                }
                                handleUpdateItemField={(value, name, index) =>
                                  handleUpdateItemField(value, name, index)
                                }
                                getData={(item) =>
                                  handleUpdateMultipleGstData(item, 0)
                                }
                                handleItemAmount={(amount) =>
                                  handleItemAmount(amount)
                                }
                                handleAdjustmentAmount={(amount) =>
                                  setAdjustmentAmount(amount)
                                }
                                handleShippingCharge={(amount) =>
                                  setShippingCharge(amount)
                                }
                                clientOption={clientOPtion}
                                handleIsFright={() => setIsFright(!isFright)}
                                isFright={isFright}
                                adjustmentAmount={adjustmentAmount}
                                shippingCharge={shippingCharge}
                                editData={editData}
                                clientValue={clientValue}
                                currency={currency}
                                totalPaymentAmount={totalPaymentAmount}
                                termsValue={termsValue}
                                invSubject={invSubject}
                                customerNotes={customerNotes}
                                moduleId={moduleInfo?._id}
                                adjustmentLabel={adjustmentLabel}
                                handleAdjustmentLabel={(e)=>setAdjustmentLabel(e.target.value)}
                              />
                            </div>
                          </Box>
                        </div>
                      )}
                    </Tab>
                    {hasAccess() && isInv && (
                      <Tab
                        eventKey="paymentRecord"
                        title={
                          <div className="d-flex ">
                            Record Payment
                            {paymentRecords?.length > 0 && (
                              <FaCheck size={12} className="tab-icon" />
                            )}
                          </div>
                        }
                        className="add-form-tab"
                      >
                        {activeTab === "paymentRecord" && (
                          <div className="form-card">
                            {paymentRecords?.length > 0 &&
                              paymentRecords.map((item, index) => {
                                return (
                                  <PaymentRecords
                                    bankOptions={bankOptions}
                                    key={`payment-info-${index}`}
                                    handleOnChange={(name, value) =>
                                      handleOnChangePaymentRecord(
                                        name,
                                        value,
                                        index
                                      )
                                    }
                                    deleteRecord={() => {
                                      deletePaymentRecord(item, index);
                                    }}
                                    autoCount={index}
                                    recordData={item}
                                    isEdit={isEdit}
                                    editData={editData}
                                    paymentRecordError={paymentRecordsError}
                                    role={role}
                                    expenseType={expenseType}
                                    clientValue={clientValue}
                                    currency={currency}
                                    totalReceivableAmt={totalReceivableAmt}
                                  />
                                );
                              })}
                            <Box display="flex" alignItems="center">
                              <h5>Add Records</h5>

                              <Button
                                className="add-btn mt-2 mx-1"
                                minWidth={0}
                                disabled={totalReceivableAmt <= 0}
                                onClick={() => {
                                  handleAddPaymentRecords();
                                }}
                              >
                                <FaPlusCircle
                                  className="add-project-icon"
                                  size={15}
                                />
                              </Button>
                            </Box>
                          </div>
                        )}
                      </Tab>
                    )}
                    {hasAccess() && (
                      <Tab
                        eventKey="Invoices"
                        title={
                          <div className="d-flex ">
                            Purchase Order
                            {(purchaseNumber ||
                              multipleInvoiceData?.length > 0) && (
                              <FaCheck size={12} className="tab-icon" />
                            )}
                          </div>
                        }
                        className="add-form-tab"
                      >
                        {activeTab === "Invoices" && (
                          <div className="form-card">
                            <Row>
                              <Col>
                                <Box display="flex" className="input-box">
                                  <Form.Label className="bill-number">
                                    Order Number #
                                  </Form.Label>

                                  <Box>
                                    <Form.Control
                                      type="text"
                                      name="purchaseNumber"
                                      placeholder="Order Number"
                                      onChange={(e) => {
                                        setPurchaseNumber(e.target.value);
                                      }}
                                      value={purchaseNumber}
                                    />
                                  </Box>
                                </Box>
                              </Col>
                              <Col>
                                <Box display="flex" className="input-box">
                                  <Form.Label>Order Date</Form.Label>
                                  <Box>
                                    <DatePicker
                                      name="purchaseDate"
                                      className={`monthDate`}
                                      dateFormat="dd-MMM-yyyy"
                                      onChange={(date) => {
                                        setPurchaseDate(date);
                                      }}
                                      selected={purchaseDate}
                                      showMonthDropdown={true}
                                      showYearDropdown={true}
                                      dropdownMode="select"
                                    />
                                  </Box>
                                </Box>
                              </Col>
                            </Row>
                            <div
                              className="form-card"
                              style={{ marginBottom: "0px" }}
                            >
                              <Box display="flex" alignItems="center">
                                <h5>Purchase Order</h5>
                                <Button
                                  className="add-project mt-1"
                                  onClick={() => {
                                    handleInvoiceChange();
                                  }}
                                >
                                  <FaPlusCircle
                                    className="add-project-icon"
                                    size={15}
                                  />
                                </Button>
                              </Box>
                              <Box display="flex">
                                <span
                                  className=" mt-2"
                                  style={{ color: "red", fontSize: "14px" }}
                                >
                                  * File must be less then 2Mb
                                </span>
                                {multipleInvoiceData &&
                                  multipleInvoiceData?.length >= 5 && (
                                    <strong className="mx-4 mt-2">
                                      Maximum 5 allowed
                                    </strong>
                                  )}
                              </Box>
                              {multipleInvoiceData &&
                                multipleInvoiceData?.map((item, index) => {
                                  return (
                                    <InvoiceComponent
                                      key={`invoiceData-${index}`}
                                      getInvoice={(data) =>
                                        handleUpdateInvoiceData(data, index)
                                      }
                                      selectedFile={item}
                                      handleDelete={() => {
                                        handelDeleteInvoice(index);
                                      }}
                                      handleDeleteOnEdit={(key, spId) => {
                                        handleDeleteInvoiceOnEdit(key, spId);
                                      }}
                                      isEditing={isEdit}
                                      addNewInvoiceOnEdit={(file) => {
                                        addNewInvoiceOnEdit(file, index);
                                      }}
                                      submitInvRemark={(value) => {
                                        addRemarkForInvoice(value, index);
                                      }}
                                      handleAddInvoiceRemarks={(value) => {
                                        handleAddInvoiceRemarks(value, index);
                                      }}
                                      role={role}
                                    />
                                  );
                                })}
                            </div>
                          </div>
                        )}
                      </Tab>
                    )}
                    <Tab
                      eventKey="tds"
                      title={
                        <div className="d-flex ">
                          TDS
                          {isTds && <FaCheck size={12} className="tab-icon" />}
                        </div>
                      }
                      className="add-form-tab"
                    >
                      {activeTab === "tds" && (
                        <div className="form-card">
                          <Box display="flex" alignItems="center">
                            <h5>TDS Deducted ?</h5>
                            <Form.Check
                              className="mx-1 mt-2"
                              type="switch"
                              id="custom-switch"
                              onChange={() => handleToggleTDSDeducted()}
                              checked={isTds}
                            />
                          </Box>
                          {isTds && (
                            <Box>
                              {tdsRecords &&
                                tdsRecords?.length &&
                                tdsRecords.map((record, index) => {
                                  return (
                                    <>
                                      <TdsRecords
                                        handleOnChange={(name, value) =>
                                          handleOnChangeTdsRecord(
                                            name,
                                            value,
                                            index
                                          )
                                        }
                                        autoCount={index}
                                        tdsRecord={record}
                                        role={role}
                                        deleteMultipleTdsItem={() =>
                                          deleteTdsRecord(record, index)
                                        }
                                        currency={currency}
                                        remainingTdsAmount={remainingTdsAmount}
                                      />
                                    </>
                                  );
                                })}
                            </Box>
                          )}
                          {isTds && (
                            <Box display="flex">
                              <Box display="flex">
                                <h5>Add TDS</h5>
                                <Button
                                  className="add-project mt-2"
                                  disabled={remainingTdsAmount <= 0}
                                  onClick={() => {
                                    handleAddTdsRecords();
                                  }}
                                >
                                  <FaPlusCircle
                                    className="add-project-icon mt-1"
                                    size={15}
                                  />
                                </Button>
                              </Box>
                              <Box className="total-tds-amount">
                                <Text className="heading">Total TDS : </Text>
                                <Text className="value">
                                  {currency?.symbol || "₹"}{" "}
                                  {formatAmountIndianRupees(
                                    totalTdsAmount || 0
                                  )}
                                </Text>
                              </Box>
                            </Box>
                          )}
                        </div>
                      )}
                    </Tab>

                    {hasAccess() && isInv && (
                      <Tab
                        eventKey="refund"
                        disabled={totalReceivedAmount <= 0}
                        title={
                          <div
                            className={`d-flex ${
                              totalReceivedAmount <= 0 ? "disabled-btn" : ""
                            }`}
                          >
                            Refund
                            {isRefund && (
                              <FaCheck size={12} className="tab-icon" />
                            )}
                          </div>
                        }
                        className="add-form-tab"
                      >
                        {activeTab === "refund" && (
                          <div className="form-card">
                            <Box display="flex" alignItems="center">
                              <h5>Refund Information</h5>
                              <Form.Check
                                className="mx-1 mt-2"
                                type="switch"
                                id="custom-switch"
                                checked={isRefund}
                                onChange={() => handleToggleRefundApplicable()}
                              />
                            </Box>

                            {isRefund && (
                              <Box>
                                {refundRecords &&
                                  refundRecords?.map((item, index) => {
                                    return (
                                      <RefundInfoListComponent
                                        key={`refundInfo-${index}`}
                                        getData={(data) => {
                                          handleUpdateMultipleRefundData(
                                            data,
                                            index
                                          );
                                        }}
                                        autoCount={index}
                                        paymentData={item}
                                        editData={editData}
                                        refreshEditData={refreshEditData}
                                        deleteMultipleListItem={() =>
                                          deleteMultipleRefundListItem(index)
                                        }
                                        refundAmountError={refundAmountError}
                                        expenseType={expenseType}
                                        role={role}
                                      />
                                    );
                                  })}
                              </Box>
                            )}
                            {isRefund && (
                              <Box display="flex" alignItems="center">
                                <h5>Add Refund</h5>

                                <Button
                                  className="add-project mt-2"
                                  onClick={() => {
                                    handleMultipleRefundInfo(
                                      refundRecords.length + 1
                                    );
                                  }}
                                  disabled={!isRefund}
                                >
                                  <FaPlusCircle
                                    className="add-project-icon"
                                    size={15}
                                  />
                                </Button>
                              </Box>
                            )}
                          </div>
                        )}
                      </Tab>
                    )}

                    <Tab
                      eventKey="credit"
                      title={
                        <div className="d-flex ">
                          Credit
                          {isCredit && (
                            <FaCheck size={12} className="tab-icon" />
                          )}
                        </div>
                      }
                      className="add-form-tab"
                    >
                      {activeTab === "credit" && (
                        <div className="form-card">
                          <Box display="flex" alignItems="center">
                            <h5>Credit Utilized</h5>
                            <Form.Check
                              className="mx-1 mt-2"
                              type="switch"
                              id="custom-switch"
                              checked={isCredit}
                              onChange={() => handleToggleCreditApplicable()}
                            />
                            {paymentStatus === 1 && hasAccess() && isInv && (
                              <div
                                className="add-credit-btn"
                                onClick={() => setIsAddCredit(!isAddCredit)}
                              >
                                <FaPlus
                                  size={12}
                                  className="new-plus-icon mx-1"
                                />{" "}
                                New Credit
                              </div>
                            )}
                          </Box>
                          {isCredit && (
                            <Box>
                              {multipleCredit &&
                                multipleCredit?.map((item, index) => {
                                  const isLastItem =
                                    index === multipleCredit.length - 1;

                                  return (
                                    <CreditApplicable
                                      autoCount={index}
                                      isEdit={isEdit}
                                      getData={(data) =>
                                        handleUpdatedMultipleCredit(data)
                                      }
                                      creditItem={item}
                                      deleteCredit={(id, creditId) =>
                                        handleDeleteCredit(id, creditId)
                                      }
                                      creditError={creditError}
                                      editData={editData}
                                      maxAllowedCredit={
                                        totalReceivableAmt + parseFloat(item?.usAmt || 0)
                                      }
                                      isCreditValid={setCreditValid}
                                      allCreditData={allCreditData}
                                      isDisabled={!isLastItem}
                                      currency={currency}
                                    />
                                  );
                                })}
                            </Box>
                          )}

                          {isCredit && (
                            <Box display="flex" alignItems="center">
                              <h5>Add Credit</h5>

                              <Button
                                className="add-project mt-2"
                                onClick={() => setAddCredit(!addCredit)}
                                disabled={!validateCredits() || !isCredit}
                              >
                                <FaPlusCircle
                                  className="add-project-icon"
                                  size={15}
                                />
                              </Button>
                              <Box className="mt-2 mx-4">
                                {addCredit && (
                                  <ClientProjectSelect
                                    options={allCreditOption}
                                    placeHolder={
                                      <div>Select Credit Number...</div>
                                    }
                                    onChange={(newValue) =>
                                      handleAddCredit(newValue)
                                    }
                                    isSearchable
                                    role={role}
                                  />
                                )}
                              </Box>
                            </Box>
                          )}
                        </div>
                      )}
                    </Tab>
                    {!hasAccess() && (
                      <Tab
                        eventKey="Invoices"
                        title={
                          <div className="d-flex ">
                            Purchase Order
                            {(purchaseNumber ||
                              multipleInvoiceData?.length > 0) && (
                              <FaCheck size={12} className="tab-icon" />
                            )}
                          </div>
                        }
                        className="add-form-tab"
                      >
                        {activeTab === "Invoices" && (
                          <div className="form-card">
                            <Row>
                              <Col>
                                <Box display="flex" className="input-box">
                                  <Form.Label className="bill-number">
                                    Order Number #
                                  </Form.Label>

                                  <Box>
                                    <Form.Control
                                      type="text"
                                      name="purchaseNumber"
                                      placeholder="Order Number"
                                      onChange={(e) => {
                                        setPurchaseNumber(e.target.value);
                                      }}
                                      value={purchaseNumber}
                                    />
                                  </Box>
                                </Box>
                              </Col>
                              <Col>
                                <Box display="flex" className="input-box">
                                  <Form.Label>Order Date</Form.Label>
                                  <Box>
                                    <DatePicker
                                      name="purchaseDate"
                                      className={`monthDate`}
                                      dateFormat="dd-MMM-yyyy"
                                      onChange={(date) => {
                                        setPurchaseDate(date);
                                      }}
                                      selected={purchaseDate}
                                      showMonthDropdown={true}
                                      showYearDropdown={true}
                                      dropdownMode="select"
                                    />
                                  </Box>
                                </Box>
                              </Col>
                            </Row>
                            <div
                              className="form-card"
                              style={{ marginBottom: "0px" }}
                            >
                              <Box display="flex" alignItems="center">
                                <h5>Purchase Order</h5>
                                <Button
                                  className="add-project mt-1"
                                  onClick={() => {
                                    handleInvoiceChange();
                                  }}
                                >
                                  <FaPlusCircle
                                    className="add-project-icon"
                                    size={15}
                                  />
                                </Button>
                              </Box>
                              <Box display="flex">
                                <span
                                  className=" mt-2"
                                  style={{ color: "red", fontSize: "14px" }}
                                >
                                  * File must be less then 2Mb
                                </span>
                                {multipleInvoiceData &&
                                  multipleInvoiceData?.length >= 5 && (
                                    <strong className="mx-4 mt-2">
                                      Maximum 5 allowed
                                    </strong>
                                  )}
                              </Box>
                              {multipleInvoiceData &&
                                multipleInvoiceData?.map((item, index) => {
                                  return (
                                    <InvoiceComponent
                                      key={`invoiceData-${index}`}
                                      getInvoice={(data) =>
                                        handleUpdateInvoiceData(data, index)
                                      }
                                      selectedFile={item}
                                      handleDelete={() => {
                                        handelDeleteInvoice(index);
                                      }}
                                      handleDeleteOnEdit={(key, spId) => {
                                        handleDeleteInvoiceOnEdit(key, spId);
                                      }}
                                      isEditing={isEdit}
                                      addNewInvoiceOnEdit={(file) => {
                                        addNewInvoiceOnEdit(file, index);
                                      }}
                                      submitInvRemark={(value) => {
                                        addRemarkForInvoice(value, index);
                                      }}
                                      handleAddInvoiceRemarks={(value) => {
                                        handleAddInvoiceRemarks(value, index);
                                      }}
                                      role={role}
                                    />
                                  );
                                })}
                            </div>
                          </div>
                        )}
                      </Tab>
                    )}
                    {hasAccess() && isProforma && (
                      <Tab
                        eventKey="Invoice"
                        title={
                          <div className="d-flex ">
                            Invoice
                            {isInv && (
                              <FaCheck size={12} className="tab-icon" />
                            )}
                          </div>
                        }
                        className="add-form-tab"
                      >
                        {activeTab === "Invoice" && (
                          <div className="form-card">
                            <Box className="mt-2" display="flex">
                              <Form.Label>
                                Do you want to convert into Invoice?
                              </Form.Label>
                              <Form.Check
                                type="switch"
                                id="custom-switch"
                                className="mx-1"
                                disabled={isInv}
                                onChange={handleToggleGenerateInvoice}
                                checked={isInv}
                                label={generatedNum && generatedNum}
                              />
                            </Box>
                          </div>
                        )}
                      </Tab>
                    )}
                  </Tabs>
                </div>

                {(role === "Manager" || role === "Admin") &&
                  activeList === "pending" &&
                  isEdit &&
                  paymentStatus === 0 && (
                    <>
                      <div className="form-card">
                        <h5>Approve OR Reject Remark</h5>

                        <Row>
                          <Col>
                            <Box display="flex" className="input-box">
                              <Form.Label>Remarks</Form.Label>
                              <TextAreaField
                                name="remarks"
                                value={approveOrRejectRemarks}
                                handleChange={(e) => setApproveOrRejectRemarks(e.target.value)}
                                isInvalid={
                                  !approveOrRejectRemarks &&
                                  errors?.approveOrRejectRemarks
                                }                              />
                            </Box>
                            {!approveOrRejectRemarks && (
                              <p className="form_error">
                                {errors?.approveOrRejectRemarks}
                              </p>
                            )}
                          </Col>
                        </Row>
                      </div>
                    </>
                  )}
                <Row>
                  {(role === "Manager" || role === "Admin") &&
                  activeList === "pending" &&
                  isEdit &&
                  paymentStatus === 0 ? (
                    <ModalFooter
                      style={{ alignItems: "center", justifyContent: "center" }}
                    >
                      {paymentStatus !== 1 && (
                        <div className="d-flex">
                          <Button
                            variant="brand"
                            disabled={
                              totalPaymentAmount === null ? true : false
                            }
                            onClick={() => {
                              handleTotalPayAmountIsApproved(formik.values);
                            }}
                            className="submit-btn me-2"
                          >
                            Approve
                          </Button>

                          <Button
                            className="submit-btn"
                            variant="brand"
                            disabled={
                              totalPaymentAmount === null ? true : false
                            }
                            onClick={() => handleTotalPayAmountIsRejected()}
                            style={{ background: "#191063" }}
                          >
                            Reject
                          </Button>
                        </div>
                      )}
                    </ModalFooter>
                  ) : (
                    <ModalFooter>
                      {isSendRequest() ? (
                        <Button
                          variant="brand"
                          disabled={totalPaymentAmount === null ? true : false}
                          onClick={() => {
                            handleAmountApproveBtn(formik.values);
                          }}
                          className="submit-btn"
                        >
                          Send Request
                        </Button>
                      ) : (
                        <Button
                          type="submit"
                          variant="brand"
                          className="submit-btn"
                          disabled={
                            totalReceivedAmount < 0 || remainingTdsAmount < 0
                          }
                          onClick={() => setCompareDataModal(true)}
                          style={{ background: "#191063" }}
                        >
                          Submit
                        </Button>
                      )}
                    </ModalFooter>
                  )}
                </Row>
              </Form>
            </ModalBody>
          )}
        </ModalContent>
      </Modal>

      {compareDataModal && comparingData && (
        <InvoiceDataChangeModal
          openModal={compareDataModal}
          closeModal={closeComparedDataModal}
          editData={editData}
          currentData={comparingData}
          isConfirmed={() => {
            submitUpdateData(comparingData, editData);
          }}
          type={expenseType}
          role={role}
          moduleTyp={moduleInfo?.typ}
        />
      )}

      {isAddCredit && (
        <CreditForm
          isOpen={isAddCredit}
          closeModal={() => {
            setIsAddCredit(false);
          }}
          remainingAmount={totalPaymentAmount}
          editData={editData}
          expenseType={expenseType}
          clientId={clientValue}
          role={role}
          moduleInfo={moduleInfo}
        />
      )}
      {isSetting && (
        <InvoiceNumberSetting
          isOpen={isSetting}
          onClose={() => setIsSetting(false)}
          invPrefix={invPrefix}
          handleInvoiceSetting={(data) => handleInvoiceSetting(data)}
          moduleId={moduleInfo?._id}
        />
      )}
      {isPfSetting && (
        <ProformaNumberSetting
          isOpen={isPfSetting}
          onClose={() => setIsPfSetting(false)}
          pfiPrefix={pfiPrefix}
          handleProformaSetting={(data) => handleProformaSetting(data)}
          moduleId={moduleInfo?._id}
        />
      )}
    </>
  );
};

export default SalesInvoiceForm;
